// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:13:19.016Z
// Property: White Oak Estates (ID: 6767906449164876)
// Collections: 14 amenities, 8 floorplans (live), 34 photos, 44 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449164876",
  "property_external_id": "5453169",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/white-oak-estates-jackson-ms/8eqpkr3/",
  "property_google_business_url": "https://www.google.com/maps/place/White+Oak+Estates/data=!4m2!3m1!1s0x0:0x26dd9b22740a6263?sa=X&ved=2ahUKEwj2o5_rzrySAxUzqpUCHWHaKm0Q_BJ6BAgMEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "26354748042",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "white-oak-estates",
  "property_name": "White Oak Estates",
  "property_website_url": "https://www.whiteoaksestates.com/",
  "property_domain": "https://www.whiteoaksestates.com/",
  "property_address": "759 Glencross Drive",
  "property_full_address": "755 Glencross Dr, Jackson, MS 39206",
  "property_address_1": "755 Glencross Drive",
  "property_address_2": null,
  "property_address_city": "Jackson",
  "property_address_state": "MS",
  "property_address_zip_full": null,
  "property_address_zip": "39206",
  "property_address_country": "US",
  "property_address_county": "Hinds County",
  "property_neighborhood_address": null,
  "property_address_latitude": "32.3897445",
  "property_address_longitude": "-90.1623193",
  "property_email": "whiteoakestates@rrliving.com",
  "property_phone": "6016200032",
  "property_call_tracking_phone": "601-891-1531",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to White Oak Estates, where comfort meets convenience in Jackson, MS. Enjoy resort-style amenities like a refreshing pool, a modern fitness center, and a dog park for your furry friends. With spacious floor plans and controlled access, your ideal home awaits. Start your journey today—check out our availability!",
  "property_long_description": "**Welcome to White Oak Estates – Your Ideal Apartment Community in Jackson, MS!**\n\nNestled in the heart of Jackson, White Oak Estates offers a serene and vibrant living experience that perfectly balances comfort and convenience. Our diverse floor plans cater to a variety of lifestyles, ensuring you find the perfect space to call home. Each apartment features modern amenities such as air conditioning, washer/dryer hookups, and elegant hardwood floors. Enjoy the luxury of walk-in closets and balconies or patios that invite you to unwind while soaking in the views.\n\nAt White Oak Estates, we prioritize community and convenience. Take advantage of our exceptional amenities, including a sparkling pool to cool off during those warm Mississippi summers, a fully-equipped fitness center to maintain your active lifestyle, and a spacious playground for our young residents. Socialize and relax in our inviting clubhouse, all while staying connected with our community-wide Wi-Fi.\n\nSafety and accessibility are at the forefront of our community, with controlled access, on-site maintenance, and a property manager ready to assist you 24/7. Our gated environment ensures peace of mind, while our dog park is perfect for furry companions to roam and play. Public transportation options further enhance the convenience of living at White Oak Estates.\n\nWhether you’re looking for a cozy one-bedroom or a spacious two-bedroom apartment, you'll find the perfect home in our community.\n\nFind your new home today—browse our availability or schedule a tour to visit White Oak Estates and experience the lifestyle you deserve!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-b448-7189-9ea5-251168f9e744.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a multi-story apartment building with exterior staircases and balconies.",
    "public_id": "019d082d-b448-7189-9ea5-251168f9e744",
    "storage_key": "property/6767906449164876/019d082d-b448-7189-9ea5-251168f9e744.webp",
    "width": 998,
    "height": 665
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "432",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "87.5",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Each apartment may have up to 3 pets, with a limit of 2 dogs per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://whiteoakestatesapartments.loftliving.com/login",
  "property_apply_now_url": "https://9173956.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9e68-7558-ab12-6f1b676a7ff3.webp",
  "property_primary_logo_media": {
    "alt_text": "White Oak Estates logo",
    "public_id": "019e849e-9e68-7558-ab12-6f1b676a7ff3",
    "storage_key": "property/6767906449164876/019e849e-9e68-7558-ab12-6f1b676a7ff3.webp",
    "width": 2048,
    "height": 2048
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-a87c-75ab-92c4-1afd2e1370cd.webp",
  "property_secondary_logo_media": {
    "alt_text": "White Oak Estates logo with a tree and the words \"WHITE OAK ESTATES\"",
    "public_id": "019d082d-a87c-75ab-92c4-1afd2e1370cd",
    "storage_key": "property/6767906449164876/019d082d-a87c-75ab-92c4-1afd2e1370cd.webp",
    "width": 200,
    "height": 177
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e8e87-0016-73aa-a696-86b1a9b34380.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-0016-73aa-a696-86b1a9b34380",
    "storage_key": "property/6767906449164876/019e8e87-0016-73aa-a696-86b1a9b34380.webp",
    "width": 1280,
    "height": 1280
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e8e86-ec82-7199-bd12-ad895e5f9a49.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-ec82-7199-bd12-ad895e5f9a49",
    "storage_key": "property/6767906449164876/019e8e86-ec82-7199-bd12-ad895e5f9a49.webp",
    "width": 1280,
    "height": 1280
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#1b566a",
  "property_secondary_color": "#c7d3d6",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#c7d3d6",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "900 - 1349",
  "property_sqft_min": "900",
  "property_sqft_max": "1349",
  "property_price_range": "800 - 1210",
  "property_price_min": "800",
  "property_price_max": "1210",
  "property_available_units": 54,
  "property_facebook_url": "https://www.facebook.com/people/White-Oak-Estates/100090323207298/#",
  "property_instagram_url": "https://www.instagram.com/whiteoakestates_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJyzBjWVDNKYYRY2IKdCKb3SY",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/white-oak-estates-by-beztak-properties-jackson",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to White Oak Estates",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Enjoy living the good life at White Oak Estates! Located in Jackson, Mississippi. Our spacious 1, 2, and 3 bedroom apartments were designed with the resident lifestyle in mind. With features like a clubhouse, two sparkling swimming pools, bark park and playground it’s easy to see why our residents love living here.</p>",
  "property_home_floorplans_blurb": "<p>At White Oaks Estates, our residents find that our convenient location in Jackson, Mississippi is <a href=\"/amenities/\">perfect for both work and play.</a> Within minutes you can visit, The Jackson Zoo and Mississippi Agriculture and Forestry Museum.</p>\n<p>With several well-known employers in the area, White Oaks Estates Apartments offers an easy commute for our residents. Local employers include Tougaloo College, GE and Jackson State University. And for those traveling a bit further, you can easily access the I-220.</p>\n<p>With many major shopping, restaurants, and entertainment venues nearby, it’s easy to immerse yourself in all that the surrounding area that White Oaks Estates has to offer.</p>",
  "property_home_gallery_blurb": "At White Oak Estates in Jackson, MS, choose from spacious one, two, or three-bedroom layouts to suit your lifestyle. Indulge in premier amenities, from shimmering pools to a vibrant bark park. With modern finishes, 24-hour maintenance, and a welcoming community, picture yourself living here and enjoying every moment!",
  "property_home_neighborhood_blurb": "At White Oak Estates in Jackson, MS, the charm of our vibrant neighborhood awaits you. Experience the allure of local favorites and hidden gems, all just moments from your doorstep. Uncover intriguing points of interest nearby that enhance your living experience. Come, see what makes our community truly special!",
  "property_home_reviews_blurb": "At White Oak Estates in Jackson, MS, residents rave about our dedicated team, stating, “Briana and Tia are literally the best!” Enjoy spacious, well-maintained apartments in a serene environment. Experience the perfect blend of comfort, quality service, and convenience today! See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At White Oak Estates in Jackson, MS, vibrant living meets local charm. Enjoy a rich tapestry of experiences nearby, from the engaging Mississippi Museum of Natural Science to the serene LeFleur's Bluff State Park. Discover engaging cultural sites and recreational havens that add excitement to your everyday life. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At White Oak Estates in Jackson, MS, enjoy a lifestyle where modern comforts meet community charm. Dive into our shimmering pool, work out in the fitness center, or unwind at the clubhouse. With spacious floor plans and amenities like walk-in closets and a dog park, your perfect home awaits!",
  "property_applynow_blurb": "At White Oak Estates in Jackson, MS, your ideal living experience awaits amidst inviting amenities like a refreshing pool, a fitness center, and a dog park for furry friends. Enjoy convenience and comfort with on-site maintenance, controlled access, and stylish floor plans. Lease your new home online today!",
  "property_contactus_blurb": "At White Oak Estates in Jackson, MS, we offer a variety of thoughtfully designed floor plans to suit your lifestyle. Experience comfort and convenience in our welcoming community. Have questions? Our friendly leasing team is here to help—reach out today and take the first step toward your ideal home!",
  "property_faqs_blurb": "At White Oak Estates in Jackson, MS, your comfort is our priority. Our thoughtfully designed floor plans cater to diverse lifestyles and preferences. Got questions? Our FAQs page is your gateway to insights about our community. Delight in the details that make White Oak Estates your ideal home.",
  "property_floorplans_blurb": "At White Oak Estates in Jackson, MS, our diverse floor plans cater to every lifestyle, blending comfort and modern design. Whether you seek spacious living or cozy nooks, our community offers the ideal setting for your next chapter. Browse our available apartment homes today and envision your future! ",
  "property_gallery_blurb": "At White Oak Estates in Jackson, MS, picture yourself enjoying luxurious living surrounded by stunning hardwood floors and walk-in closets. Dive into our refreshing pool, unwind in the clubhouse, or cherish moments at the playground. With gated access and community-wide WiFi, your ideal home awaits. Experience life elevated!",
  "property_interactivemap_blurb": "At White Oak Estates in Jackson, MS, modern living meets convenience! Enjoy resort-style amenities such as a sparkling pool, fitness center, and dog park, all within a gated community. With spacious floor plans and on-site management, your perfect apartment awaits. Access our interactive map today to find your new home!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At White Oak Estates in Jackson, MS, we believe that great friends make great neighbors! Elevate your living experience by inviting someone special to share the charm of our vibrant community. Refer a friend today and enjoy rewards that add even more joy to your new home.",
  "property_residentaccess_blurb": "At White Oak Estates in Jackson, MS, your comfort is just a click away. Access your resident portal to pay rent, schedule maintenance, and manage your home seamlessly. Don’t miss out on the convenience at your fingertips—log in today to elevate your living experience!",
  "property_reviews_blurb": "At White Oak Estates in Jackson, MS, residents rave about our exceptional service and community ambiance. \"Briana and Tia are literally the best!\" exclaims one resident. Our welcoming atmosphere, attentive management, and prompt maintenance ensure a smooth, stress-free living experience. See what our residents have to say about calling us home!",
  "property_created_at": "1750107801815",
  "property_scheduletour_blurb": "At White Oak Estates in Jackson, MS, experience spacious living with diverse floor plans tailored to your lifestyle. Join our vibrant community and schedule a tour today! Curious about resident experiences? Dive into their stories and see why White Oak Estates is the perfect place to call home!",
  "property_thankyou_blurb": "Thank you for reaching out to White Oak Estates in Jackson, MS! We appreciate your interest. Keep an eye on your inbox; our dedicated team will soon share insights about our diverse floor plans, designed to elevate your living experience. Welcome to a vibrant community that feels like home!",
  "property_virtualtours_blurb": "Step into the inviting charm of White Oak Estates in Jackson, MS. With diverse floor plans that cater to your lifestyle, each apartment offers a unique blend of comfort and elegance. Ready to envision your new home? Experience it all through our immersive virtual tour today!",
  "property_copyright": "2025 All Rights Reserved. White Oak Estates",
  "property_seo_title_home": "White Oak Estates | Apartments in Jackson, MS",
  "property_seo_description_home": "Welcome to White Oak Estates, your sanctuary in the heart of Jackson, MS! With an array of floor plans to fit your lifestyle, enjoy premium amenities like a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. Our gated community offers controlled access, on-site maintenance, and 24-hour access for your peace of mind. Relax in style with hardwood floors, walk-in closets, and private outdoor spaces. Embrace convenient living with community-wide Wi-Fi and easy public transportation options. Find your new home today at White Oak Estates—where comfort meets community!",
  "property_seo_title_floorplans": "Floor Plans | false Apartments in Jackson, MS",
  "property_seo_description_floorplans": "Find your ideal living space at White Oak Estates in Jackson, MS! Our diverse range of thoughtfully designed floor plans caters to all lifestyles. Whether you seek cozy studios or spacious two-bedroom apartments, we have the perfect fit for you. Browse our available apartment homes today and step into your next chapter of comfort and style!",
  "property_seo_title_amenities": "Amenities | Jackson, MS Apartments for Rent",
  "property_seo_description_amenities": "Experience the perfect blend of comfort and convenience at White Oak Estates in Jackson, MS. Our thoughtfully designed apartments feature spacious floor plans with hardwood floors, walk-in closets, and modern amenities. Dive into relaxation at our shimmering pool, stay active in our fitness center, or enjoy quality time at the on-site playground and clubhouse. With 24-hour access, controlled entry, and a dedicated property manager, your safety and comfort are our top priorities. Plus, furry friends are welcome in our dog park! Let your new chapter begin—unravel the lifestyle that awaits you today!",
  "property_seo_title_gallery": "Gallery | Apartments in Jackson, MS",
  "property_seo_description_gallery": "\"Step into the serene charm of White Oak Estates in Jackson, MS, where comfort meets community. Browse our vibrant Photo Gallery to envision your life surrounded by top-tier amenities, from a refreshing pool and expansive fitness center to cozy clubhouses and dog parks. Whether it’s enjoying your morning coffee on a private balcony or staying fit just steps away, you’ll find a lifestyle that reflects your dreams. Ready to make it a reality? Picture yourself living here!\"",
  "property_seo_title_virtualtours": "Virtual Tours | White Oak Estates Apartments",
  "property_seo_description_virtualtours": "Experience the charm of White Oak Estates in Jackson, MS, where comfort meets style! Step inside our inviting apartments through an immersive virtual tour that showcases our diverse floor plans. Uncover the perfect space for your lifestyle and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | White Oak Estates Apartments",
  "property_seo_description_interactivemap": "Experience the charm of White Oak Estates in Jackson, MS, where comfort meets convenience. With an array of modern floor plans and amenities—including a sparkling pool, fitness center, dog park, and inviting clubhouse—you'll have everything you need right at your doorstep. Our walk-up community offers 24-hour access, controlled entry, and public transportation, making daily life seamless. Use our interactive community map to find your perfect apartment—complete with hardwood floors, walk-in closets, and private outdoor spaces. Your new home awaits at White Oak Estates!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Jackson, MS",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Jackson, MS, at White Oak Estates. Nestled in a welcoming neighborhood, our community is surrounded by local favorites, parks, and hidden gems waiting to be explored. Dive into the area’s rich culture and amenities—your ideal lifestyle is just around the corner. Ready to find your next adventure?",
  "property_seo_title_contact": "Contact Us | White Oak Estates",
  "property_seo_description_contact": "\"At White Oak Estates in Jackson, MS, your ideal living space awaits. With a variety of thoughtfully designed floor plans, our apartment community blends comfort and style. Have questions? Our friendly leasing team is here to help you find your perfect home. Reach out today!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Jackson, MS",
  "property_seo_description_faqs": "Unlock the secrets of White Oak Estates in Jackson, MS, where modern living meets tranquil comforts. With a range of stylish floor plans and top-notch amenities—including a sparkling pool, state-of-the-art fitness center, and private dog park—you'll find your perfect home in our gated community. Enjoy the ease of on-site management, 24-hour access, and a clubhouse that’s perfect for gatherings. Have questions? Our FAQs page is your go-to resource for all things White Oak Estates. Dive in and discover the lifestyle you deserve!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Jackson, MS",
  "property_seo_description_reviews": "Experience the charm of White Oak Estates in Jackson, MS, where community spirit shines through. Dive into our vibrant lifestyle, complete with a sparkling pool, modern fitness center, and inviting dog park. Residents enjoy spacious floor plans, on-site maintenance, and 24-hour access, all within a gated haven. Don't just take our word for it; see what our residents have to say about their exceptional living experience today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Jackson, MS",
  "property_seo_description_applynow": "Unlock the door to modern living at White Oak Estates in Jackson, MS! With spacious floor plans and unbeatable amenities, including a refreshing pool, state-of-the-art fitness center, and a vibrant dog park, your ideal lifestyle awaits. Enjoy the convenience of controlled access, on-site maintenance, and community-wide Wi-Fi. Whether you’re relaxing on your private balcony, playing at the playground, or utilizing our wheelchair-accessible features, your comfort is our priority. Ready to elevate your living experience? Apply now and secure your new home today!",
  "property_seo_title_residentaccess": "Resident Access | White Oak Estates",
  "property_seo_description_residentaccess": "\"Welcome to the resident portal of White Oak Estates in Jackson, MS! Enjoy seamless access to pay rent, schedule maintenance, and stay connected with your community. Your convenient living experience starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | White Oak Estates",
  "property_seo_description_referafriend": "\"At White Oak Estates in Jackson, MS, we believe that great friends make the best neighbors. Share the experience of vibrant living and inviting community by referring a friend today. Join us in creating cherished moments and lasting connections!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | White Oak Estates",
  "property_seo_description_scheduletour": "Experience the charm of White Oak Estates in Jackson, MS! Your dream apartment is just a tour away. From spacious layouts to serene surroundings, see for yourself why our community feels like home. Schedule your visit today!",
  "property_seo_title_privacy": "Privacy Policy | White Oak Estates",
  "property_seo_description_privacy": "At White Oak Estates in Jackson, MS, your comfort and trust are our top priorities. Dive into our Privacy Policy to see how we protect your personal information while providing you with a seamless living experience. Your peace of mind starts here—learn more about our commitment to your privacy today!",
  "property_seo_title_accessibility": "Website Accessibility | White Oak Estates",
  "property_seo_description_accessibility": "At White Oak Estates in Jackson, MS, we prioritize accessibility for all our residents. Our commitment to digital inclusion ensures everyone can navigate our online resources with ease. Join us in creating a welcoming community where everyone belongs. Explore our Accessibility Statement to learn more!",
  "property_seo_title_sitemap": "Sitemap | White Oak Estates",
  "property_seo_description_sitemap": "Unlock the essence of community living at White Oak Estates in Jackson, MS. Navigate our comprehensive sitemap to uncover all the details that make our apartment community the perfect place to call home. Your ideal living experience awaits!",
  "property_seo_title_thankyou": "Thank You | White Oak Estates",
  "property_seo_description_thankyou": "Thank you for reaching out to White Oak Estates in Jackson, MS! Your request is in good hands, and we'll connect soon to guide you through the journey to your new home. Get ready to embrace the comfort and charm of our vibrant community!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jackson, MS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293563821",
  "amenities": [
    {
      "id": "ec_bf44a33c719ca2a5dcc182e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a767d758e806795f3b52624",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Two Sparkling Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39375c643604b07ff3f81266",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4538add8d997a73de9af225f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17080d5bd609abc11ff6e745",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc57221a264ac68b64174586",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Maintenance Response Guarantee",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ad66059e6582046700773ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Professional Onsite Management Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80e6e2bced92600678b2322f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Online Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_015df0ae05ab4c06d5962edb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Renovated Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c85957b3b8c7b424310420a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0897d2f09d7b0b1ead562e2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Kitchen Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d48edbae56653a364f142f03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Full Size Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d85f7ed4a9e8041cbbbd6553",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Vinyl Wood Plank Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6602f2ff1543269e98eff17c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "external_id": "false",
      "title": "Patios/Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_36300689-fddc-4796-b565-69ac9aa63d16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9f3b-7458-8746-2e6ffa80b5b3.webp",
      "image_media": {
        "alt_text": "Exterior of a 3-story apartment building with gray siding, black balconies and outdoor staircases.",
        "public_id": "019e849e-9f3b-7458-8746-2e6ffa80b5b3",
        "storage_key": "property/6767906449164876/019e849e-9f3b-7458-8746-2e6ffa80b5b3.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Discover comfortable living in this charming 3-story apartment building featuring spacious balconies and convenient exterior staircases.",
      "link": "",
      "alt_text": "Exterior of a 3-story apartment building with gray siding, black balconies and outdoor staircases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4cd8cb73-565c-4e3a-af2b-064d72a1c970",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9cf7-74b9-bf9b-6c3fde8c57fd.webp",
      "image_media": {
        "alt_text": "Lobby with seating and dining area, with exterior view through doors.",
        "public_id": "019e849e-9cf7-74b9-bf9b-6c3fde8c57fd",
        "storage_key": "property/6767906449164876/019e849e-9cf7-74b9-bf9b-6c3fde8c57fd.webp",
        "width": 1360,
        "height": 907
      },
      "title": "Community",
      "description": "Enjoy a comfortable and stylish lobby area with ample seating and a dining table, perfect for residents and guests.",
      "link": "",
      "alt_text": "Lobby with seating and dining area, with exterior view through doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_168b3f70-147f-4468-843d-a64d6a84abda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-aa57-73e9-9676-2b0bf2c8235a.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and granite countertops.",
        "public_id": "019e849e-aa57-73e9-9676-2b0bf2c8235a",
        "storage_key": "property/6767906449164876/019e849e-aa57-73e9-9676-2b0bf2c8235a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, sleek granite countertops, and black appliances, offering a stylish and functional space.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e5c21f0-ea86-4cf9-b625-686d41fb4d43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-a7af-753e-b9c4-583d5fe05c9a.webp",
      "image_media": {
        "alt_text": "Living room with orange sofa, blue chair, and double doors.",
        "public_id": "019e849e-a7af-753e-b9c4-583d5fe05c9a",
        "storage_key": "property/6767906449164876/019e849e-a7af-753e-b9c4-583d5fe05c9a.webp",
        "width": 1360,
        "height": 907
      },
      "title": "Apartment",
      "description": "Cozy living room featuring an orange sofa, a stylish blue accent chair, and double doors leading to the outdoors. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with orange sofa, blue chair, and double doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a46cb914-4596-4baa-8a2f-203405504647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9d09-7264-a2b4-4c0d41ea8bfd.webp",
      "image_media": {
        "alt_text": "Living room with a navy blue sofa, coffee table, colorful rug, and kitchen counter with bar stools.",
        "public_id": "019e849e-9d09-7264-a2b4-4c0d41ea8bfd",
        "storage_key": "property/6767906449164876/019e849e-9d09-7264-a2b4-4c0d41ea8bfd.webp",
        "width": 984,
        "height": 656
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable navy blue sofa, a modern coffee table, and a vibrant rug. The open layout connects to a well-equipped kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a navy blue sofa, coffee table, colorful rug, and kitchen counter with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9fd292f5-7f27-41bb-82d8-87852b1979a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9e06-73ef-8394-06e69a4884ba.webp",
      "image_media": {
        "alt_text": "Playground with slides and picnic tables.",
        "public_id": "019e849e-9e06-73ef-8394-06e69a4884ba",
        "storage_key": "property/6767906449164876/019e849e-9e06-73ef-8394-06e69a4884ba.webp",
        "width": 1360,
        "height": 907
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides, climbing structures, and picnic tables for family gatherings.",
      "link": "",
      "alt_text": "Playground with slides and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5149d490-82f0-4663-850b-efa75a71f488",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-b938-72e1-a4cd-018d8ba60c66.webp",
      "image_media": {
        "alt_text": "Fitness area with weights, medicine balls, and yoga balls.",
        "public_id": "019e849e-b938-72e1-a4cd-018d8ba60c66",
        "storage_key": "property/6767906449164876/019e849e-b938-72e1-a4cd-018d8ba60c66.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active and healthy in our community fitness center, equipped with free weights, medicine balls, and yoga balls for a complete workout.",
      "link": "",
      "alt_text": "Fitness area with weights, medicine balls, and yoga balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc8470db-a012-47bc-ae0c-6c0c579ce2d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9ca8-7078-8ded-3615138e38ae.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
        "public_id": "019e849e-9ca8-7078-8ded-3615138e38ae",
        "storage_key": "property/6767906449164876/019e849e-9ca8-7078-8ded-3615138e38ae.webp",
        "width": 1040,
        "height": 652
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully updated kitchen, featuring ample cabinet space, sleek granite countertops, and modern stainless steel appliances. Perfect for any home chef!",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92547e19-efd2-4128-b8a9-c5b29f3fd02a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9db4-75c9-8f1b-09061ee5bc9d.webp",
      "image_media": {
        "alt_text": "A small dining table with two chairs near a window in a common area.",
        "public_id": "019e849e-9db4-75c9-8f1b-09061ee5bc9d",
        "storage_key": "property/6767906449164876/019e849e-9db4-75c9-8f1b-09061ee5bc9d.webp",
        "width": 1360,
        "height": 907
      },
      "title": "Community",
      "description": "A common area space with a small dining table and chairs, offering a view of the outdoors through large windows and glass doors.",
      "link": "",
      "alt_text": "A small dining table with two chairs near a window in a common area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a74a42cf-b74a-4260-b590-66e618eefb37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-c252-7788-a151-b994b369b30b.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel sink, dishwasher, and washer/dryer in adjacent laundry room.",
        "public_id": "019e849e-c252-7788-a151-b994b369b30b",
        "storage_key": "property/6767906449164876/019e849e-c252-7788-a151-b994b369b30b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, a double stainless steel sink, and a dishwasher. Includes a separate laundry area with a washer and dryer.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel sink, dishwasher, and washer/dryer in adjacent laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36460a08-e29d-4c64-8313-1bce3ffe24ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-c9ae-746c-89d4-729e25d22203.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and window overlooking apartments.",
        "public_id": "019e849e-c9ae-746c-89d4-729e25d22203",
        "storage_key": "property/6767906449164876/019e849e-c9ae-746c-89d4-729e25d22203.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and a large window with blinds. This room offers a view of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and window overlooking apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d5da8abc-e2d0-4d82-a43e-4888148d1d00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-bc9b-75fc-8a5f-bbabedaf1be9.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dark wood-look flooring and white cabinets.",
        "public_id": "019e849e-bc9b-75fc-8a5f-bbabedaf1be9",
        "storage_key": "property/6767906449164876/019e849e-bc9b-75fc-8a5f-bbabedaf1be9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area and modern kitchen with dark wood-look flooring, white cabinets, and black appliances.",
      "link": "",
      "alt_text": "Living room and kitchen area with dark wood-look flooring and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80bf1bd6-1bf0-4f80-be17-80a562f9efd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-c8d0-76cd-8606-0214606b04a0.webp",
      "image_media": {
        "alt_text": "A clean and modern bathroom with a white toilet and a white bathtub and shower combination.",
        "public_id": "019e849e-c8d0-76cd-8606-0214606b04a0",
        "storage_key": "property/6767906449164876/019e849e-c8d0-76cd-8606-0214606b04a0.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a white toilet and a white bathtub with a shower, offering a clean and functional space.",
      "link": "",
      "alt_text": "A clean and modern bathroom with a white toilet and a white bathtub and shower combination.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15d54953-9aae-4ad5-840c-3a82e025bb1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-c7cc-709b-8821-bc2cdeaa678d.webp",
      "image_media": {
        "alt_text": "Interior view of a vacant apartment, showing a ceiling fan, white door, and wood-look flooring.",
        "public_id": "019e849e-c7cc-709b-8821-bc2cdeaa678d",
        "storage_key": "property/6767906449164876/019e849e-c7cc-709b-8821-bc2cdeaa678d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this apartment featuring a modern ceiling fan, elegant wood-look flooring, and ample natural light. View of a white interior door.",
      "link": "",
      "alt_text": "Interior view of a vacant apartment, showing a ceiling fan, white door, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6a3b2ba-07c6-4ae8-96ae-21f9d96211e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-c803-7129-9898-a13af4aa7f96.webp",
      "image_media": {
        "alt_text": "Ceiling fan and doors inside a bedroom.",
        "public_id": "019e849e-c803-7129-9898-a13af4aa7f96",
        "storage_key": "property/6767906449164876/019e849e-c803-7129-9898-a13af4aa7f96.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a modern ceiling fan and access to a walk-in closet.",
      "link": "",
      "alt_text": "Ceiling fan and doors inside a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a054a4e-7d11-4703-92d4-891b490e1b8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-bbd8-745b-9c0b-da88bda439c8.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and closet.",
        "public_id": "019e849e-bbd8-745b-9c0b-da88bda439c8",
        "storage_key": "property/6767906449164876/019e849e-bbd8-745b-9c0b-da88bda439c8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space, and neutral-toned walls, creating a serene atmosphere. The flooring is a stylish wood-look laminate.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f215b50-d31f-415c-973c-ed9db9ba016f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-b9bf-765b-83f5-0d5af4fd8f29.webp",
      "image_media": {
        "alt_text": "A lounge area with bean bag chairs and a TV on the wall.",
        "public_id": "019e849e-b9bf-765b-83f5-0d5af4fd8f29",
        "storage_key": "property/6767906449164876/019e849e-b9bf-765b-83f5-0d5af4fd8f29.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable lounge area, complete with plush bean bag chairs and a mounted television for your entertainment.",
      "link": "",
      "alt_text": "A lounge area with bean bag chairs and a TV on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b3afa66d-5f87-49c9-a1ed-0573a71a92e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-bc03-712f-affe-0414d900359b.webp",
      "image_media": {
        "alt_text": "Living room with ceiling fan and access to balcony.",
        "public_id": "019e849e-bc03-712f-affe-0414d900359b",
        "storage_key": "property/6767906449164876/019e849e-bc03-712f-affe-0414d900359b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a ceiling fan and access to a balcony with blinds.",
      "link": "",
      "alt_text": "Living room with ceiling fan and access to balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5927b6eb-0d9a-4fe7-9555-11de71596a16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-bdad-705f-8c1f-c99a898bc0c5.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and neutral walls.",
        "public_id": "019e849e-bdad-705f-8c1f-c99a898bc0c5",
        "storage_key": "property/6767906449164876/019e849e-bdad-705f-8c1f-c99a898bc0c5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty closet with wire shelving and neutral walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1304bd3c-3656-4077-bbf4-aeaef3a12f81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-b9ec-7441-9984-e907b9f6821b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black sink, and stainless steel appliances.",
        "public_id": "019e849e-b9ec-7441-9984-e907b9f6821b",
        "storage_key": "property/6767906449164876/019e849e-b9ec-7441-9984-e907b9f6821b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white shaker cabinets, elegant granite countertops, and a deep black sink, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, black sink, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd54d186-3791-45ef-af66-13c5f6113900",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-baca-7189-b1ca-7a5e15db8371.webp",
      "image_media": {
        "alt_text": "Living area with a ceiling fan, doorway to kitchen, and glass French doors leading outside.",
        "public_id": "019e849e-baca-7189-b1ca-7a5e15db8371",
        "storage_key": "property/6767906449164876/019e849e-baca-7189-b1ca-7a5e15db8371.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a ceiling fan, laminate wood flooring, and access to the kitchen and an outdoor patio.",
      "link": "",
      "alt_text": "Living area with a ceiling fan, doorway to kitchen, and glass French doors leading outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ffbed97-5a5f-47ff-87c0-0bb28c2490a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-b9d8-70b9-9c53-6d5149e41900.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and two windows.",
        "public_id": "019e849e-b9d8-70b9-9c53-6d5149e41900",
        "storage_key": "property/6767906449164876/019e849e-b9d8-70b9-9c53-6d5149e41900.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, neutral gray walls, and large windows for ample natural light. Modern wood-look flooring adds a stylish touch.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de0331d8-163e-4a12-a930-ce9e62a4215c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-b411-7119-97ff-865596ac3be6.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and elliptical machines.",
        "public_id": "019e849e-b411-7119-97ff-865596ac3be6",
        "storage_key": "property/6767906449164876/019e849e-b411-7119-97ff-865596ac3be6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio and strength training equipment for your convenience.",
      "link": "",
      "alt_text": "Fitness center with treadmills and elliptical machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d4cf1809-da8f-4fd1-b899-75832263508c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-ac3b-723d-8901-33cd8afe5728.webp",
      "image_media": {
        "alt_text": "Exterior view of a community building with a paved walkway and lush green lawn.",
        "public_id": "019e849e-ac3b-723d-8901-33cd8afe5728",
        "storage_key": "property/6767906449164876/019e849e-ac3b-723d-8901-33cd8afe5728.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Beautiful exterior of a community building, surrounded by manicured lawns and trees, offering a welcoming ambiance.",
      "link": "",
      "alt_text": "Exterior view of a community building with a paved walkway and lush green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_681a4f1b-cfd8-4091-ad54-6f61c913e81e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-ad83-7375-8d51-d972e5720b32.webp",
      "image_media": {
        "alt_text": "Interior of a kids' play area with a TV, bean bag chair, and decorative alphabet art on the wall.",
        "public_id": "019e849e-ad83-7375-8d51-d972e5720b32",
        "storage_key": "property/6767906449164876/019e849e-ad83-7375-8d51-d972e5720b32.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "A bright and engaging kids' play area, perfect for children to relax and have fun, featuring comfortable seating and educational decor.",
      "link": "",
      "alt_text": "Interior of a kids' play area with a TV, bean bag chair, and decorative alphabet art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1eb5a4c9-6f39-4ba6-9113-789af6ba33f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-ab0f-761c-b47d-0f25110f0edf.webp",
      "image_media": {
        "alt_text": "Office reception area with a desk, computers, and chairs.",
        "public_id": "019e849e-ab0f-761c-b47d-0f25110f0edf",
        "storage_key": "property/6767906449164876/019e849e-ab0f-761c-b47d-0f25110f0edf.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to our modern and functional office reception area, designed for efficiency and comfort.",
      "link": "",
      "alt_text": "Office reception area with a desk, computers, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_184c6afe-7220-484c-aa79-6194570282c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-ad15-740d-a965-6e4f7bbbdefd.webp",
      "image_media": {
        "alt_text": "Communal seating area with tables and chairs next to an outdoor swimming pool.",
        "public_id": "019e849e-ad15-740d-a965-6e4f7bbbdefd",
        "storage_key": "property/6767906449164876/019e849e-ad15-740d-a965-6e4f7bbbdefd.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the pool and then relax in our comfortable communal seating area, perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Communal seating area with tables and chairs next to an outdoor swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e49d38dd-5136-402e-ad60-98fee88283ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-aa5f-717e-974c-e1be7742b58c.webp",
      "image_media": {
        "alt_text": "A dining table with two chairs in a room with a TV and a window.",
        "public_id": "019e849e-aa5f-717e-974c-e1be7742b58c",
        "storage_key": "property/6767906449164876/019e849e-aa5f-717e-974c-e1be7742b58c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A modern dining area featuring a wooden table, comfortable chairs, and a wall-mounted television.",
      "link": "",
      "alt_text": "A dining table with two chairs in a room with a TV and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5227f581-9aca-433f-9c08-39418b85dfd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-ac3a-77fc-812a-5818f37fc48e.webp",
      "image_media": {
        "alt_text": "Modern leasing office with desk, chairs, and decor.",
        "public_id": "019e849e-ac3a-77fc-812a-5818f37fc48e",
        "storage_key": "property/6767906449164876/019e849e-ac3a-77fc-812a-5818f37fc48e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, designed for your comfort and convenience. Features a professional workspace and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Modern leasing office with desk, chairs, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a44e322b-ceb8-45cf-b87d-b3b6a9a2272f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-ab2c-77b3-a747-115eecd1af3b.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, toilet, and bathtub.",
        "public_id": "019e849e-ab2c-77b3-a747-115eecd1af3b",
        "storage_key": "property/6767906449164876/019e849e-ab2c-77b3-a747-115eecd1af3b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this modern bathroom featuring a sleek vanity, spacious mirror, clean toilet, and a pristine bathtub, perfect for unwinding.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, mirror, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd7c259d-cfa3-406b-b635-9286ea763f48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-a98c-761d-830a-fcf1136a5da7.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with ceiling fan and laminate flooring",
        "public_id": "019e849e-a98c-761d-830a-fcf1136a5da7",
        "storage_key": "property/6767906449164876/019e849e-a98c-761d-830a-fcf1136a5da7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a modern kitchen, featuring a ceiling fan and stylish laminate flooring. Perfect for comfortable living.",
      "link": "",
      "alt_text": "Living room and kitchen area with ceiling fan and laminate flooring",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2bd6b35-d92e-4a9d-a529-46f0182c77ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9d13-70cb-852e-a87a6b4c1786.webp",
      "image_media": {
        "alt_text": "Bathroom with a white tub, toilet, and vanity with a granite countertop.",
        "public_id": "019e849e-9d13-70cb-852e-a87a6b4c1786",
        "storage_key": "property/6767906449164876/019e849e-9d13-70cb-852e-a87a6b4c1786.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a spacious white tub, a convenient toilet, and a stylish vanity with a granite countertop. This bathroom is designed for comfort and functionality.",
      "link": "",
      "alt_text": "Bathroom with a white tub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3bcff86f-7645-41fa-8e34-2479079589ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9e1c-72cf-95e1-40b0a325f3ec.webp",
      "image_media": {
        "alt_text": "A home office setup with a desk, chair, bookshelf, and artwork on the wall.",
        "public_id": "019e849e-9e1c-72cf-95e1-40b0a325f3ec",
        "storage_key": "property/6767906449164876/019e849e-9e1c-72cf-95e1-40b0a325f3ec.webp",
        "width": 984,
        "height": 656
      },
      "title": "Apartment",
      "description": "Create your ideal home office in this spacious room, perfect for remote work or study. Features a desk, chair, bookshelf, and stylish decor.",
      "link": "",
      "alt_text": "A home office setup with a desk, chair, bookshelf, and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_360fab3d-6402-44c8-bf98-266d2405261b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e849e-9d44-777c-a131-fb08b33b134a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, white rug, and two windows.",
        "public_id": "019e849e-9d44-777c-a131-fb08b33b134a",
        "storage_key": "property/6767906449164876/019e849e-9d44-777c-a131-fb08b33b134a.webp",
        "width": 984,
        "height": 656
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed with stylish bedding, a plush white rug, and two large windows allowing natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, white rug, and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ed82e9d1-9262-4404-852c-7df8a4faeecb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Mama Hamil's Southern Cookin' and Bar B Que Buffet",
      "poi_type": "Restaurants",
      "poi_address": "480 Magnolia St, Madison, MS 39110, USA",
      "poi_short_description": "Casual restaurant serving fried chicken and other Southern comfort food with an all-you-can-eat option.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious fried chicken, ribs, and a wide variety of soul food options, including chicken livers and gizzards, vegetables, and homemade rolls. They also highlight the friendly and attentive staff, reasonable prices, and generous portions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-0b0d-75db-af52-60ab7e46b8d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-0b0d-75db-af52-60ab7e46b8d1",
        "storage_key": "property/6767906449164876/019d082e-0b0d-75db-af52-60ab7e46b8d1.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.hamils.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010288085330032935",
      "poi_item_slug": "mama-hamils-southern-cookin-and-bar-b-que-buffet",
      "poi_latitude": "32.444675",
      "poi_longitude": "-90.122784",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-856-4407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7082-738e-b89e-8af66095a3b6",
        "storage_key": "property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3jiACfSKYYRJ_nPuK1mzJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_36c8ce24-de4c-42f9-9c9a-8c934e8747d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "988 Top St, Flowood, MS 39232, USA",
      "poi_short_description": "Family-friendly buffet with an array of American fare, from breakfast to dinner.",
      "poi_long_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-fdbc-766d-90ab-3e7752e4e113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082d-fdbc-766d-90ab-3e7752e4e113",
        "storage_key": "property/6767906449164876/019d082d-fdbc-766d-90ab-3e7752e4e113.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.goldencorral.com/locations/682/golden-corral-top-street?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=682&utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=682",
      "poi_directions_map_url": "https://maps.google.com/?cid=5732979269932144382",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "32.327924",
      "poi_longitude": "-90.121621",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-420-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7082-738e-b89e-8af66095a3b6",
        "storage_key": "property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdgWVRctKIYR_tb7eEWij08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_3f814c28-f2c7-4135-bc9d-0c5e74643bbd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "202 E Layfair Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Chain eatery serving its familiar chicken finger meals for lunch and dinner.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken tenders with great sauce, and they appreciate the quick and friendly service. They also highlight the fresh food and efficient drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-038c-729c-8001-d3b4a229727e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-038c-729c-8001-d3b4a229727e",
        "storage_key": "property/6767906449164876/019d082e-038c-729c-8001-d3b4a229727e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ms/flowood/202-e.-layfair-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=119709276499798027",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.3313599",
      "poi_longitude": "-90.1053988",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-933-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7082-738e-b89e-8af66095a3b6",
        "storage_key": "property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHz4FBecsKIYRC-gW5vNKqQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0b347743-e971-4eaa-95f8-29204ed37817",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "The Pig & Pint",
      "poi_type": "Restaurants",
      "poi_address": "3139 N State St, Jackson, MS 39216, USA",
      "poi_short_description": "Eatery for BBQ, craft beer, and cocktails in a laid-back setting with outdoor seating.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious ribs, brisket, pulled pork, and pork belly corn dogs, alongside a great selection of local beers. They also highlight the friendly and helpful staff, reasonable prices, and comfortable outdoor seating area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-03a9-7604-aa37-ddf3c3d2411c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-03a9-7604-aa37-ddf3c3d2411c",
        "storage_key": "property/6767906449164876/019d082e-03a9-7604-aa37-ddf3c3d2411c.webp",
        "width": 1280,
        "height": 1105
      },
      "poi_business_url": "http://www.pigandpint.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1476363693019893403",
      "poi_item_slug": "the-pig--pint",
      "poi_latitude": "32.3372449",
      "poi_longitude": "-90.1762962",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7082-738e-b89e-8af66095a3b6",
        "storage_key": "property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8cgFMMyKIYRmw686fQYfRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_cbc86d72-5536-4f5d-9251-761e5b7cf5c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Walk-On's Sports Bistreaux - Ridgeland Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "720 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain restaurant and sports bar featuring scratch-made dishes, beer, and cocktails.",
      "poi_long_description": "Diners say this sports bar serves up delicious cheese sticks, gumbo, pasta, and a wide selection of drinks. They also highlight the friendly and attentive service, as well as the lively and fun atmosphere, making it a great spot for a casual meal or watching a game.\n\nSome reviews mention the noise level can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-05d1-7467-ad8a-dc3082a13e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-05d1-7467-ad8a-dc3082a13e5f",
        "storage_key": "property/6767906449164876/019d082e-05d1-7467-ad8a-dc3082a13e5f.webp",
        "width": 700,
        "height": 393
      },
      "poi_business_url": "https://locate.walk-ons.com/ms/ridgeland/restaurants-418.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3366707697943520067",
      "poi_item_slug": "walk-ons-sports-bistreaux---ridgeland-restaurant",
      "poi_latitude": "32.424255",
      "poi_longitude": "-90.1486204",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-345-4747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7082-738e-b89e-8af66095a3b6",
        "storage_key": "property/6767906449164876/019d082e-7082-738e-b89e-8af66095a3b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjURAnVjTKYYRQyN_TtDyuC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e71ab659-a774-4c5e-b8e7-a86745648697",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Northpark",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Climate-controlled mall with 120+ shops, a food court, an arcade, and a play area.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops selling food, clothes, and shoes, with a focus on hip hop apparel and jewelry. They also highlight the ample parking, good security, and happy atmosphere.\n\nSome reviews mention the mall can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-0e77-73df-b69c-d35853cc2f9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-0e77-73df-b69c-d35853cc2f9c",
        "storage_key": "property/6767906449164876/019d082e-0e77-73df-b69c-d35853cc2f9c.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://www.visitnorthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14074278564042696477",
      "poi_item_slug": "northpark",
      "poi_latitude": "32.4030556",
      "poi_longitude": "-90.1291667",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-863-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7077-74fc-aec1-f2c77dcb2050.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7077-74fc-aec1-f2c77dcb2050",
        "storage_key": "property/6767906449164876/019d082e-7077-74fc-aec1-f2c77dcb2050.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhY9vW4rSKYYRHeeoB8nhUcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8548b744-a049-42c3-b667-02f9a60cf18b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4500 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Grocery chain with organic and natural products, including prepared foods, baked goods, and pizza, plus a salad bar.",
      "poi_long_description": "Shoppers say this grocery store offers a great selection of fresh vegetables, high-quality meats, and a delicious salad bar. They also highlight the friendly and helpful staff, and the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-1049-75e3-91ff-f0a5a922fb01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-1049-75e3-91ff-f0a5a922fb01",
        "storage_key": "property/6767906449164876/019d082e-1049-75e3-91ff-f0a5a922fb01.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/jkn?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173301360047794626",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.3543087",
      "poi_longitude": "-90.1502174",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-608-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7076-7097-9413-bedaa7bed8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7076-7097-9413-bedaa7bed8be",
        "storage_key": "property/6767906449164876/019d082e-7076-7097-9413-bedaa7bed8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8w7oKoyKIYRwqnRtMr30LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_54a9ccb0-20a1-44ff-b0f4-b26c77807cdc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4910 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Chain grocery outpost for produce, meats, household goods, and prepared foods, plus passport photos.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-0c53-777c-bf13-5fdfc8cd3fe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-0c53-777c-bf13-5fdfc8cd3fe0",
        "storage_key": "property/6767906449164876/019d082e-0c53-777c-bf13-5fdfc8cd3fe0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ms/jackson/jacksonian-plaza/025/00345?cid=loc_02500345_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562485936542992699",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.3637911",
      "poi_longitude": "-90.1479131",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-366-1141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7076-7097-9413-bedaa7bed8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7076-7097-9413-bedaa7bed8be",
        "storage_key": "property/6767906449164876/019d082e-7076-7097-9413-bedaa7bed8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_-AxKsyKIYRO0l8f2bqVq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_35801c72-ad2b-4488-87ff-d198e3366c1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6325 Interstate 55 North Frontage Rd, Jackson, MS 39213, USA",
      "poi_short_description": "Chain home improvement store offering tools, appliances, hardware, and building materials, plus installation services.",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-14c4-73ed-8351-4720ca6606e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-14c4-73ed-8351-4720ca6606e4",
        "storage_key": "property/6767906449164876/019d082e-14c4-73ed-8351-4720ca6606e4.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Northeast-Jackson/MS/Jackson/39213/2902?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13511686515734280697",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.3952681",
      "poi_longitude": "-90.1484678",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-952-0740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7077-74fc-aec1-f2c77dcb2050.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7077-74fc-aec1-f2c77dcb2050",
        "storage_key": "property/6767906449164876/019d082e-7077-74fc-aec1-f2c77dcb2050.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQfhBHoLSKYYR-fnGTkwng7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_090d08e5-8dfa-4dd1-8bfa-ba3102bb6d25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Renaissance at Colony Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "Open-air shopping mall with restaurants and a European design theme, plus a movie theater.",
      "poi_long_description": "People say this shopping center is clean and well-maintained with a beautiful fountain and a variety of shops and restaurants. They also highlight the relaxing atmosphere, especially at night when the fountain is illuminated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-164c-7254-94cf-7d2ef92950a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-164c-7254-94cf-7d2ef92950a4",
        "storage_key": "property/6767906449164876/019d082e-164c-7254-94cf-7d2ef92950a4.webp",
        "width": 701,
        "height": 396
      },
      "poi_business_url": "http://www.renaissanceatcolonypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1390767190390103411",
      "poi_item_slug": "renaissance-at-colony-park",
      "poi_latitude": "32.4356677",
      "poi_longitude": "-90.1465128",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-519-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7077-74fc-aec1-f2c77dcb2050.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7077-74fc-aec1-f2c77dcb2050",
        "storage_key": "property/6767906449164876/019d082e-7077-74fc-aec1-f2c77dcb2050.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr8vq_wjSKYYRc114HGT_TBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_250c5f9b-2435-4a60-a6f9-cb1e2b302c18",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Belhaven University",
      "poi_type": "Education",
      "poi_address": "1500 Peachtree St, Jackson, MS 39202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-16f5-71f9-9b8f-042f6655384e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-16f5-71f9-9b8f-042f6655384e",
        "storage_key": "property/6767906449164876/019d082e-16f5-71f9-9b8f-042f6655384e.webp",
        "width": 640,
        "height": 428
      },
      "poi_business_url": "https://www.belhaven.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4999850342803410694",
      "poi_item_slug": "belhaven-university",
      "poi_latitude": "32.3198074",
      "poi_longitude": "-90.169346",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-968-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-70ae-73b5-8734-779103573af1",
        "storage_key": "property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZZC_xfIyKIYRBo_pfGUJY0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9f94e4a3-ab58-4a7c-857c-6ffaaba44095",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Millsaps College",
      "poi_type": "Education",
      "poi_address": "1701 N State St, Jackson, MS 39210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-17a3-7527-b795-46abc8ded2a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-17a3-7527-b795-46abc8ded2a8",
        "storage_key": "property/6767906449164876/019d082e-17a3-7527-b795-46abc8ded2a8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.millsaps.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15814363996952354658",
      "poi_item_slug": "millsaps-college",
      "poi_latitude": "32.3223479",
      "poi_longitude": "-90.1780014",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-974-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-70ae-73b5-8734-779103573af1",
        "storage_key": "property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoz-AEOUyKIYRYl8SY0Tod9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0d43980f-a17a-4420-acb0-f09926ec6c66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Holmes Community College",
      "poi_type": "Education",
      "poi_address": "412 W Ridgeland Ave, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-2055-719f-ad65-e16448848b9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-2055-719f-ad65-e16448848b9d",
        "storage_key": "property/6767906449164876/019d082e-2055-719f-ad65-e16448848b9d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://holmescc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907095702532732739",
      "poi_item_slug": "holmes-community-college",
      "poi_latitude": "32.4371517",
      "poi_longitude": "-90.1391745",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-856-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-70ae-73b5-8734-779103573af1",
        "storage_key": "property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RKR5BrSKYYRQzcXM_Lu2l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f8ca5664-dc26-4407-a21c-a4a77c13ee1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Tougaloo College",
      "poi_type": "Education",
      "poi_address": "500 W County Line Rd, Tougaloo, MS 39174, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-2a02-7799-b117-12f680083bf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-2a02-7799-b117-12f680083bf0",
        "storage_key": "property/6767906449164876/019d082e-2a02-7799-b117-12f680083bf0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tougaloo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573720754771851030",
      "poi_item_slug": "tougaloo-college",
      "poi_latitude": "32.4048193",
      "poi_longitude": "-90.160845",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-977-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-70ae-73b5-8734-779103573af1",
        "storage_key": "property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJewwN-pzNKYYRFve9zbQdnqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2ca74197-98ea-4fd3-a19b-583aca898114",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Mississippi Museum of Natural Science",
      "poi_type": "Entertainment",
      "poi_address": "2148 Riverside Dr, Jackson, MS 39202, USA",
      "poi_short_description": "Aquarium showcasing native fish, amphibians, and reptiles, as well as outdoor trails.",
      "poi_long_description": "Visitors say this museum features a variety of dinosaur fossils, a mini aquarium with turtles, alligators, and fish, and walking trails. They also highlight the friendly and helpful staff, reasonable admission prices, and the engaging exhibits that are fun for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-1f47-70b0-95d7-1417744ded26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-1f47-70b0-95d7-1417744ded26",
        "storage_key": "property/6767906449164876/019d082e-1f47-70b0-95d7-1417744ded26.webp",
        "width": 1204,
        "height": 804
      },
      "poi_business_url": "https://www.mdwfp.com/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=9206655217532860533",
      "poi_item_slug": "mississippi-museum-of-natural-science",
      "poi_latitude": "32.3249191",
      "poi_longitude": "-90.1572274",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-576-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bd-76e2-a7c0-dd6d9c9866ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bd-76e2-a7c0-dd6d9c9866ba",
        "storage_key": "property/6767906449164876/019d082e-75bd-76e2-a7c0-dd6d9c9866ba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6VeP5AyKIYRdfiKMiScxH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_febf18d6-f8b0-42be-95e6-4d592614ecd1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Mississippi Veterans Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2531 N State St, Jackson, MS 39216, USA",
      "poi_short_description": "Stadium for football games and other events, such as homecoming and tailgating.",
      "poi_long_description": "Large, grass-field venue with over 60,000 seats, home to Jackson State University's football team.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-2607-7389-be18-6e79225a8965.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-2607-7389-be18-6e79225a8965",
        "storage_key": "property/6767906449164876/019d082e-2607-7389-be18-6e79225a8965.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ms-veteransstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9012324547599246743",
      "poi_item_slug": "mississippi-veterans-memorial-stadium",
      "poi_latitude": "32.3296361",
      "poi_longitude": "-90.1797842",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-354-6021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75b4-765f-adeb-0b7f88928d97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75b4-765f-adeb-0b7f88928d97",
        "storage_key": "property/6767906449164876/019d082e-75b4-765f-adeb-0b7f88928d97.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc7ZDKOYyKIYRl6UvPG01En0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_527780eb-0e9c-42e6-96a2-6af4ee243ec1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Mississippi Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "2145 Museum Blvd, Jackson, MS 39202, USA",
      "poi_short_description": "Children's museum offering educational, interactive exhibits and programs.",
      "poi_long_description": "Visitors say this children's museum offers a multi-sensory experience with educational play areas and a great playground. They also highlight the value of the membership, which provides ongoing access to the museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-2851-721f-8965-e8af8bf44e38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-2851-721f-8965-e8af8bf44e38",
        "storage_key": "property/6767906449164876/019d082e-2851-721f-8965-e8af8bf44e38.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://mschildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9429186362770771731",
      "poi_item_slug": "mississippi-childrens-museum",
      "poi_latitude": "32.32870030000001",
      "poi_longitude": "-90.1571926",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-981-5469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bd-76e2-a7c0-dd6d9c9866ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bd-76e2-a7c0-dd6d9c9866ba",
        "storage_key": "property/6767906449164876/019d082e-75bd-76e2-a7c0-dd6d9c9866ba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJffLKlpkyKIYRE8_o-Qkz24I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_913eaa2b-2436-4299-b7f4-0273002c1373",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Mississippi Civil Rights Museum",
      "poi_type": "Entertainment",
      "poi_address": "222 North St #2205, Jackson, MS 39201, USA",
      "poi_short_description": "Museum exploring Mississippi’s role in the civil rights movement with displays and a restaurant.",
      "poi_long_description": "Visitors say this history museum offers a riveting and educational journey through the Civil Rights movement, featuring engaging exhibits, artifacts, and the opportunity to speak with individuals who were part of the struggle. They also highlight the friendly and knowledgeable staff, and the museum's thought-provoking and powerful presentation of history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-2dde-702c-b8ba-b42b0ae9fffa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-2dde-702c-b8ba-b42b0ae9fffa",
        "storage_key": "property/6767906449164876/019d082e-2dde-702c-b8ba-b42b0ae9fffa.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://mscivilrightsmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1264626766470263930",
      "poi_item_slug": "mississippi-civil-rights-museum",
      "poi_latitude": "32.3015024",
      "poi_longitude": "-90.1776853",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-576-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bd-76e2-a7c0-dd6d9c9866ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bd-76e2-a7c0-dd6d9c9866ba",
        "storage_key": "property/6767906449164876/019d082e-75bd-76e2-a7c0-dd6d9c9866ba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8wegR1AyKIYRejTpBFjbjBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_316913b5-133a-49cd-a3d6-037addb63d90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "6370 Ridgewood Ct Dr, Jackson, MS 39211, USA",
      "poi_short_description": "Indoor entertainment center with trampolines, climbing structures, go karts, and other kid-friendly attractions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-30b1-730c-8735-f8a04b60952f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-30b1-730c-8735-f8a04b60952f",
        "storage_key": "property/6767906449164876/019d082e-30b1-730c-8735-f8a04b60952f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.urbanair.com/mississippi-jackson/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3514114226054270296",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.3958583",
      "poi_longitude": "-90.1364822",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-566-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9gZoZjTKYYRWI0cIEWkxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_17fe44be-38a1-4d58-a3cf-d53c085cb111",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "772 Lake Harbour Dr # 1, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain fitness center offering a variety of workout equipment in a clean, relaxed environment.",
      "poi_long_description": "People say this gym has a wide variety of well-maintained equipment, including treadmills, ellipticals, bikes, rowing machines, and weight machines, and they appreciate the spacious layout. They also highlight the friendly and helpful staff, and the clean and well-lit facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-3220-747e-a7ae-b8b44676af11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-3220-747e-a7ae-b8b44676af11",
        "storage_key": "property/6767906449164876/019d082e-3220-747e-a7ae-b8b44676af11.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/ridgeland-ms?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17295786995903098070",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.4155597",
      "poi_longitude": "-90.1107937",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-427-5901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSGVmpnTKYYR1uyfwaL6BvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bbfca120-bbb2-4206-a103-340b11105a1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Animal Emergency & Referral Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1009 Treetops Blvd, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-38df-7238-ae4e-255a8c62caab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-38df-7238-ae4e-255a8c62caab",
        "storage_key": "property/6767906449164876/019d082e-38df-7238-ae4e-255a8c62caab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cvm.msstate.edu/aerc-home",
      "poi_directions_map_url": "https://maps.google.com/?cid=12162414471896174386",
      "poi_item_slug": "animal-emergency--referral-center",
      "poi_latitude": "32.3255648",
      "poi_longitude": "-90.1194963",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-939-8999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzq8QxotKIYRMg9x4IWTyag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_b8bb05e0-1bae-4c74-ab83-7e9eeeae60ec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "CLUB4 Fitness Lake Harbour",
      "poi_type": "Health and Wellness",
      "poi_address": "511 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Membership-only gym offering equipment, classes, child care, a pool, and a rock climbing wall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-3c02-72fe-b966-880203535d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-3c02-72fe-b966-880203535d03",
        "storage_key": "property/6767906449164876/019d082e-3c02-72fe-b966-880203535d03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.club4fitness.com/location/lake-harbour/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6318120847339163222",
      "poi_item_slug": "club4-fitness-lake-harbour",
      "poi_latitude": "32.4133465",
      "poi_longitude": "-90.1175495",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-605-9886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTFhXUPSKYYRVg6kkW95rlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_15be51eb-b866-45ec-9865-f76b0ae1f68e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "GRIT Training",
      "poi_type": "Health and Wellness",
      "poi_address": "2625 Courthouse Cir, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-40f9-716e-bb50-a4504ea54c45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-40f9-716e-bb50-a4504ea54c45",
        "storage_key": "property/6767906449164876/019d082e-40f9-716e-bb50-a4504ea54c45.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.grit-ms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2231842918902481768",
      "poi_item_slug": "grit-training",
      "poi_latitude": "32.3272575",
      "poi_longitude": "-90.1152147",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-487-2443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6cx-GwtKIYRaEOnV08Z-R4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_633ada64-98ad-4391-9630-8b794cf53f6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Crunch Fitness - Ridgeland",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain fitness center offering a variety of classes, tanning, and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-3f2b-759c-ab30-3eb69cf33003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-3f2b-759c-ab30-3eb69cf33003",
        "storage_key": "property/6767906449164876/019d082e-3f2b-759c-ab30-3eb69cf33003.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/ridgeland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16000032341730509397",
      "poi_item_slug": "crunch-fitness---ridgeland",
      "poi_latitude": "32.4010391",
      "poi_longitude": "-90.1096038",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-360-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfpJ8fjSKYYRVcKbm6SIC94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8da13ef9-3106-48ef-8001-aff0d2b2960e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Madison Healthplex Performance Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Baptist Dr, Madison, MS 39110, USA",
      "poi_short_description": "Large gym with a pool, hot tub, and cold plunge, plus a variety of group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-43b9-75a9-99aa-3861531579b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-43b9-75a9-99aa-3861531579b3",
        "storage_key": "property/6767906449164876/019d082e-43b9-75a9-99aa-3861531579b3.webp",
        "width": 981,
        "height": 768
      },
      "poi_business_url": "http://www.healthplexperformance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10695343614279382681",
      "poi_item_slug": "madison-healthplex-performance-training-center",
      "poi_latitude": "32.470621",
      "poi_longitude": "-90.1372865",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-856-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0v5kMLRKYYRmXbdz1l-bZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_688ffe9f-d976-4b88-a2d5-93ddb13ad985",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "FitNetWork",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Lake Cir, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-4857-709f-b64b-52f67efc373e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-4857-709f-b64b-52f67efc373e",
        "storage_key": "property/6767906449164876/019d082e-4857-709f-b64b-52f67efc373e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fitnetworkusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882937850049824834",
      "poi_item_slug": "fitnetwork",
      "poi_latitude": "32.4700843",
      "poi_longitude": "-90.1610645",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 769-300-0194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu6Fvg1_PKYYRQogXKumIRns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_38b4bfd0-6274-4684-9cb3-97f39f568039",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Courthouse Gymnastics Co",
      "poi_type": "Health and Wellness",
      "poi_address": "698 Liberty Rd, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-4a06-769e-b9f3-6e6c4afb7ed8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-4a06-769e-b9f3-6e6c4afb7ed8",
        "storage_key": "property/6767906449164876/019d082e-4a06-769e-b9f3-6e6c4afb7ed8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.courthousegymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10353510153888683355",
      "poi_item_slug": "courthouse-gymnastics-co",
      "poi_latitude": "32.3435763",
      "poi_longitude": "-90.0878897",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-932-6680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-70ae-73b5-8734-779103573af1",
        "storage_key": "property/6767906449164876/019d082e-70ae-73b5-8734-779103573af1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhS3gP_osKIYRW1XvNKEOr48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b98c6273-7888-4e6a-b5c6-a89202ce4dce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Sky Nails In Jackson",
      "poi_type": "Health and Wellness",
      "poi_address": "665 Duling Ave, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-4c82-752a-8627-57d6080dae92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-4c82-752a-8627-57d6080dae92",
        "storage_key": "property/6767906449164876/019d082e-4c82-752a-8627-57d6080dae92.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://facebook.com/skynails39216",
      "poi_directions_map_url": "https://maps.google.com/?cid=16766559719273743297",
      "poi_item_slug": "sky-nails-in-jackson",
      "poi_latitude": "32.3353652",
      "poi_longitude": "-90.1742096",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 769-235-8903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3lVBt0zKIYRwUOvTDvJrug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_21167c3c-86ec-41d6-a847-8098b40c45d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "St. Dominic Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "969 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-4def-701c-bc02-bc52e879a8ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-4def-701c-bc02-bc52e879a8ee",
        "storage_key": "property/6767906449164876/019d082e-4def-701c-bc02-bc52e879a8ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fmolhs.org/locations/greater-jackson/st-dominics-hospital?utm_source=Google&utm_medium=listing&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=2322937810740476467",
      "poi_item_slug": "st-dominic-hospital",
      "poi_latitude": "32.3326096",
      "poi_longitude": "-90.1653002",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-200-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-77cb-779c-b491-7ae797a36bf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-77cb-779c-b491-7ae797a36bf6",
        "storage_key": "property/6767906449164876/019d082e-77cb-779c-b491-7ae797a36bf6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYdRlJUyKIYRM3qCpKG7PCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_35255ee1-e6a8-44d2-a57f-1356ab0998cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1225 N State St, Jackson, MS 39202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-51ae-75a1-bb8c-6dbd565fb57c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-51ae-75a1-bb8c-6dbd565fb57c",
        "storage_key": "property/6767906449164876/019d082e-51ae-75a1-bb8c-6dbd565fb57c.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.baptsitonline.org/mbmc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17608872070341135515",
      "poi_item_slug": "baptist-medical-center",
      "poi_latitude": "32.3150536",
      "poi_longitude": "-90.1794976",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-968-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-77cb-779c-b491-7ae797a36bf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-77cb-779c-b491-7ae797a36bf6",
        "storage_key": "property/6767906449164876/019d082e-77cb-779c-b491-7ae797a36bf6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJwarCCvkyKIYRmwz7J9pHX_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6f7db6bc-c0af-441f-8c87-a3d7e73c0de6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "LeFleur's Bluff State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3315 Lakeland Terrace, Jackson, MS 39216, USA",
      "poi_short_description": "State park offering hiking, disc golf, a playground, and campgrounds, plus a natural science museum.",
      "poi_long_description": "Visitors say this state park offers scenic walking trails, a playground, and a campground with fishing opportunities and alligators. They also highlight the peaceful atmosphere and convenient location near the city with surrounding food options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-5282-7024-8be9-8e56175b51af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-5282-7024-8be9-8e56175b51af",
        "storage_key": "property/6767906449164876/019d082e-5282-7024-8be9-8e56175b51af.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.mdwfp.com/parks-destinations/park/lefleurs-bluff-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18333674287180082174",
      "poi_item_slug": "lefleurs-bluff-state-park",
      "poi_latitude": "32.3308055",
      "poi_longitude": "-90.1489668",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-987-3923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b74-7228-8527-a39370de274a",
        "storage_key": "property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTspAmItKIYR_usU06BLbv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_b9a1d546-20fa-4ab7-ab39-b513f581ec0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Freedom Ridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "253 W School St, Ridgeland, MS 39157, USA",
      "poi_short_description": "Park featuring a playground, picnic tables, sports fields, and a walking trail.",
      "poi_long_description": "Visitors say this park is a great place for kids to play and is also popular for soccer games. They like that it's a friendly environment and is good for dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-54b1-772b-886a-7a6058ee5bfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-54b1-772b-886a-7a6058ee5bfa",
        "storage_key": "property/6767906449164876/019d082e-54b1-772b-886a-7a6058ee5bfa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridgelandms.org/city-departments/recreation-and-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15546985984956168474",
      "poi_item_slug": "freedom-ridge",
      "poi_latitude": "32.4197477",
      "poi_longitude": "-90.1413081",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b74-7228-8527-a39370de274a",
        "storage_key": "property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSKa83HSKYYRGvlJwWH9wdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e0eac04c-7a4e-4859-a52e-f1214aca6486",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Old Trace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "422 Post Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Park with a playground, picnic areas, restrooms, walking trails, and a disc golf course.",
      "poi_long_description": "Recreation area with picnic tables & reservoir views, plus an annual show by the local symphony.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-5562-730a-90e5-a72711ef33a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-5562-730a-90e5-a72711ef33a0",
        "storage_key": "property/6767906449164876/019d082e-5562-730a-90e5-a72711ef33a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.therez.ms.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671602723425758356",
      "poi_item_slug": "old-trace-park",
      "poi_latitude": "32.4274039",
      "poi_longitude": "-90.0823689",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b74-7228-8527-a39370de274a",
        "storage_key": "property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfITFPPTKYYRlCzCroVwEyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e3822501-975b-4402-9928-66bb805e55e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Strawberry Patch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "271 St Augustine Dr, Madison, MS 39110, USA",
      "poi_short_description": "Public park with a playground, picnic tables, walking path, pond, and track.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-5b6b-7279-8cb0-5cafaba303d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-5b6b-7279-8cb0-5cafaba303d9",
        "storage_key": "property/6767906449164876/019d082e-5b6b-7279-8cb0-5cafaba303d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.madisonthecity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6879852727507967850",
      "poi_item_slug": "strawberry-patch-park",
      "poi_latitude": "32.4502084",
      "poi_longitude": "-90.1051547",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-853-9109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b74-7228-8527-a39370de274a",
        "storage_key": "property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkfxdBn3RKYYRal8dypolel8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b8eb88cd-e5f1-4baf-be7a-acd2ecce9ab7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Flowood Liberty Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Unnamed Road, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-5b86-75ba-93df-01c21bf252b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-5b86-75ba-93df-01c21bf252b0",
        "storage_key": "property/6767906449164876/019d082e-5b86-75ba-93df-01c21bf252b0.webp",
        "width": 1280,
        "height": 1052
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8220269399056143777",
      "poi_item_slug": "flowood-liberty-park",
      "poi_latitude": "32.3464135",
      "poi_longitude": "-90.0864976",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b74-7228-8527-a39370de274a",
        "storage_key": "property/6767906449164876/019d082e-7b74-7228-8527-a39370de274a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0z5Z5wtKIYRoVXBMHdDFHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_208def48-0fab-4a03-b43b-82e0ecbc023f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Hawkins Field Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "558 W Ramp St, Jackson, MS 39209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-5d20-72e8-8823-518f2e6b8768.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-5d20-72e8-8823-518f2e6b8768",
        "storage_key": "property/6767906449164876/019d082e-5d20-72e8-8823-518f2e6b8768.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://jmaa.com/hawkins-field/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6486129544765008496",
      "poi_item_slug": "hawkins-field-airport",
      "poi_latitude": "32.3384132",
      "poi_longitude": "-90.2283782",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-948-8778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b97-724e-8d1c-ec86981e40b2",
        "storage_key": "property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJB9wYVV4zKIYRcGriunRcA1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1333b806-948e-41c7-9b5d-8ea279aeb9ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Bruce Campbell Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-5d0e-765e-b71b-b3bc66890d07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-5d0e-765e-b71b-b3bc66890d07",
        "storage_key": "property/6767906449164876/019d082e-5d0e-765e-b71b-b3bc66890d07.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202379395653693271",
      "poi_item_slug": "bruce-campbell-field",
      "poi_latitude": "32.4400825",
      "poi_longitude": "-90.1052932",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b97-724e-8d1c-ec86981e40b2",
        "storage_key": "property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRqzhNDTKYYRV-9P1k1rtX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_30e6281f-9a42-4c16-860b-204814d1482c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Madison Air LLC.",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-6329-7094-8d6d-54cb07eaac26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-6329-7094-8d6d-54cb07eaac26",
        "storage_key": "property/6767906449164876/019d082e-6329-7094-8d6d-54cb07eaac26.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11203969235679198100",
      "poi_item_slug": "madison-air-llc",
      "poi_latitude": "32.4401776",
      "poi_longitude": "-90.1051652",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b97-724e-8d1c-ec86981e40b2",
        "storage_key": "property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYe6J9HTKYYRlDsQn6h-fJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ce08b3db-dc92-42e3-be9f-8622836be0da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Jackson Municipal Airport Auth",
      "poi_type": "Transportation & Transit",
      "poi_address": "1500 Lavernet Rd, Jackson, MS 39202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-6331-7651-ac2b-72d37b792800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-6331-7651-ac2b-72d37b792800",
        "storage_key": "property/6767906449164876/019d082e-6331-7651-ac2b-72d37b792800.webp",
        "width": 1280,
        "height": 811
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091392343158169024",
      "poi_item_slug": "jackson-municipal-airport-auth",
      "poi_latitude": "32.3282205",
      "poi_longitude": "-90.2166685",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-354-1962",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-7b97-724e-8d1c-ec86981e40b2",
        "storage_key": "property/6767906449164876/019d082e-7b97-724e-8d1c-ec86981e40b2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaQ8cGYzKIYRwB2m9yodK34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_396405d8-c97e-4483-84b1-16e04a78947b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "The Powerhouse, Entergy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Echelon Pkwy, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-6412-7594-8a3e-a4aa2eee90d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-6412-7594-8a3e-a4aa2eee90d7",
        "storage_key": "property/6767906449164876/019d082e-6412-7594-8a3e-a4aa2eee90d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8770278893550025776",
      "poi_item_slug": "the-powerhouse-entergy",
      "poi_latitude": "32.396321",
      "poi_longitude": "-90.191046",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-952-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaisuv7MKYYRMLwnzy9Ktnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a2ae0f0e-fc47-4f93-853e-6456372b3db5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "C Spire Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1018 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-6450-7506-8018-a9d3b76076e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-6450-7506-8018-a9d3b76076e1",
        "storage_key": "property/6767906449164876/019d082e-6450-7506-8018-a9d3b76076e1.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.cspire.com/business",
      "poi_directions_map_url": "https://maps.google.com/?cid=8383002471184058399",
      "poi_item_slug": "c-spire-corporate-headquarters",
      "poi_latitude": "32.437348",
      "poi_longitude": "-90.147231",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 866-455-9628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0s2rPXTKYYRH8glHlVoVnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c15ab751-3489-434f-b9d6-4ec1bc1bbbf4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "Entergy Transmission HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6540 Watkins Dr, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-6a26-74ba-8ab3-02104ce4aa40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d082e-6a26-74ba-8ab3-02104ce4aa40",
        "storage_key": "property/6767906449164876/019d082e-6a26-74ba-8ab3-02104ce4aa40.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://entergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1578563261303676078",
      "poi_item_slug": "entergy-transmission-hq",
      "poi_latitude": "32.3975051",
      "poi_longitude": "-90.1912372",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2H9zv7MKYYRrtx8Lewu6BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_54163733-fec0-4db3-8e16-210b070730bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "WIS International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "405 Briarwood Dr Ste 204, Jackson, MS 39206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=723603429317288698",
      "poi_item_slug": "wis-international",
      "poi_latitude": "32.3788088",
      "poi_longitude": "-90.1517332",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-957-0181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-630XmDNKYYR-iK2MnzBCgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e1cac181-0409-450c-a695-c7a39b9a11a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "custom",
      "poi_name": "MDHS- Child Support Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "950 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mdhs.ms.gov/child-support/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1738695405663311359",
      "poi_item_slug": "mdhs--child-support-services",
      "poi_latitude": "32.4004974",
      "poi_longitude": "-90.1374969",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-359-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d082e-75bb-77de-9eaa-44e56f7776f2",
        "storage_key": "property/6767906449164876/019d082e-75bb-77de-9eaa-44e56f7776f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu1njEqnTKYYR_1Uqa0IWIRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_6515f26f-362d-4e05-a7fc-7b99d915a023",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_6d0ba772-a3d9-4dd6-a30d-085a437bb800",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d740a4d8-0d83-46dc-8dda-5a67971256f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_044534c1-3971-45f1-818e-608f182e42cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a00a9dc4-0d2d-4d05-a44e-b760787d8189",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0d099987-7652-4caf-a8c8-9ed646cb3231",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9bb5769c-40fa-4fb1-9a90-70ad0a3db476",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "rating": "5",
      "name": "Lamarcus Thomas",
      "text": "Very helpful people",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "custom_466eef07-8e90-4c26-a539-9aaf1d389758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "rating": "5",
      "name": "Jasmine Marie",
      "text": "omg made my experience so easy and laidback !",
      "date": "2026-01-30",
      "title": "false"
    },
    {
      "id": "custom_5c57476d-2484-44c3-a269-a01db619084e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "rating": "4",
      "name": "Ebony Rice Caston",
      "text": "I really appreciate all of their help and patience with me during the transition of having to move to another apartment, due to renovations. This was very unexpected and a bit stressful, but they made it lot easier. The staff was kind, caring, patient and professional and that means a lot, it's very hard to find, especially nowadays. So, I just want to say thank you, thank you, thank you, on behalf of my children and I.\n\nThe current team has been the most professional staff to work in that office since I've been living here and I've been here for three years.\n\nSo great job guys and please keep it up.\n\nUPDATE: Still here, three years later. I've actually been in this complex for 6 years. There have been some ups & downs, but, overall, things have been okay.\nMost recently, I needed the heat fixed in my apartment and it was addressed the very next day after I put the maintenance request in. Very much appreciated, especially with the cold weather that we have on the way.\nAlso, I'm really looking forward to the upcoming renovations & updates.\n\nANOTHER UPDATE: Juan & Latrice on the maintenance team are really great. My heat went out again and they did not stop until it was right. I appreciate them and their kindness, patience & professionalism. Derek, on the maintenance team is great as well. He was very kind, patient and professional with another situation that I was dealing with. And thank you to Briana, Dominique and Tia in the office for looking out for me and helping me with what was needed each time. Please keep up the great work everyone. It is very much appreciated.",
      "date": "2026-01-30",
      "title": "false"
    },
    {
      "id": "custom_001ed2a2-5e1c-4f05-80ee-1f08d924aa2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "rating": "5",
      "name": "Branden Miller",
      "text": "Juan does an amazing job!",
      "date": "2026-01-09",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_e41c173335552228ea1d1d96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "RR Living",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019e1dd4-7c4b-7030-a821-49b568221c9f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd4-7c4b-7030-a821-49b568221c9f",
        "storage_key": "property/6767906449164876/019e1dd4-7c4b-7030-a821-49b568221c9f.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "Community Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4509&fullscreen=false&autoFollow=true&autoRotate=true&autoPlay=false&hideStart=false&isolate=false&arrows=false&hideMinimap=false&hideWebsiteBtn=false&locationName=Community%20Center&uiColor=%235e59f3"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-ea36-714f-a857-5d29e1815dc9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "white-oak-estates",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876"
    },
    {
      "lead_collector_id": "0198aa47-ea9a-77c7-b581-b70d02a5122a",
      "lead_source": "FACEBOOK_ADS",
      "name": "white-oak-estates",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876"
    },
    {
      "lead_collector_id": "0198aa47-eafe-772a-9924-7b5f09557ff8",
      "lead_source": "LANDING_PAGE",
      "name": "white-oak-estates",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-jackson-ms",
      "search_query": "pet friendly apartments Jackson MS",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments Jackson MS",
      "h2_subtitle": "Discover pet-friendly living at White Oak Estates, Jackson MS. Our community welcomes you and your furry friends with open arms!",
      "page_copy": "Welcome to White Oak Estates, the go-to destination for pet friendly apartments in Jackson, MS. With a dedicated dog park, we are committed to making life enjoyable for both you and your furry companions. Our community is nestled in a convenient location, ensuring you have easy access to all of Jackson’s best offerings while providing a peaceful retreat.\n\nExperience the ease of pet-friendly living with our spacious apartments that cater to your lifestyle needs. Take advantage of our resort-style amenities, including two sparkling swimming pools and a modern fitness center. With renovated spaces and granite kitchen countertops, you will feel right at home. Controlled access and a professional onsite management team ensure that both you and your pets experience the highest level of comfort and security.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Jackson MS",
      "seo_description": "Explore pet friendly apartments in Jackson, MS at White Oak Estates. Enjoy a dog park and resort-style amenities. Join our pet-friendly community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-with-pools-hinds-county",
      "search_query": "apartments with pools in Hinds County",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Hinds County",
      "h2_subtitle": "White Oak Estates offers exceptional apartments with pools in Hinds County. Dive into relaxation and enjoy our sparkling swimming areas.",
      "page_copy": "Experience unparalleled leisure at White Oak Estates, featuring exquisite apartments with pools in Hinds County. Our community boasts two stunning swimming pools, perfect for relaxation and recreation alike. Immerse yourself in a refreshing escape from the hustle and bustle of daily life right in the heart of Jackson, MS.\n\nOur spacious, renovated apartments provide a luxurious backdrop for your lifestyle, complemented by amenities like granite kitchen countertops and a fully equipped fitness center. Whether you're lounging by the pool or engaging with our professional onsite management team, we ensure a living experience that prioritizes both comfort and convenience. With controlled access for your peace of mind, White Oak Estates is the ideal destination in Hinds County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in Hinds County",
      "seo_description": "Discover White Oak Estates' apartments with pools in Hinds County. Enjoy relaxation and premium amenities in our Jackson, MS community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-39206",
      "search_query": "fitness center apartments near 39206",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near 39206",
      "h2_subtitle": "Stay active at White Oak Estates, offering apartments with a fitness center near Zip Code 39206. Enjoy modern workout facilities at your doorstep.",
      "page_copy": "Welcome to White Oak Estates, where health-conscious living meets modern convenience. Our community offers well-appointed apartments with a state-of-the-art fitness center near the 39206 area. Whether you're a fitness enthusiast or just starting your journey, our gym provides everything you need to maintain a healthy lifestyle.\n\nLocated in Jackson, MS, our apartments offer more than just workout facilities. Enjoy amenities like two sparkling swimming pools and granite kitchen countertops in our renovated homes. With controlled access and a professional onsite management team, you can enjoy peace of mind as you pursue your fitness goals. Discover the perfect balance of work and play in a community designed with your well-being in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near 39206",
      "seo_description": "Explore White Oak Estates, offering apartments with a fitness center near 39206 in Jackson, MS. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "luxury-apartments-granite-countertops-ms",
      "search_query": "luxury apartments with granite countertops Mississippi",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Granite Countertops MS",
      "h2_subtitle": "Discover luxurious living in Mississippi with White Oak Estates' apartments featuring beautiful granite countertops and modern amenities.",
      "page_copy": "Experience the epitome of elegance at White Oak Estates, where we offer luxury apartments with granite countertops in Mississippi. Our renovated homes feature stylish and functional kitchen spaces that are perfect for both aspiring chefs and casual cooks. Revel in the sophistication of our interiors while enjoying the comfort of a vibrant community.\n\nLocated in Jackson, MS, our community isn't just about luxury interiors. Indulge in our resort-style amenities, including two sparkling swimming pools and a modern fitness center. With controlled access and a dedicated onsite management team, White Oak Estates ensures a high standard of living, combining security with elegance. Come see how our granite-accented spaces can enhance your lifestyle in Mississippi.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Granite Countertops MS",
      "seo_description": "Live in style at White Oak Estates in Mississippi. Enjoy luxury apartments with granite countertops and resort-style amenities in Jackson.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-washer-dryer-connections-jackson",
      "search_query": "apartments with washer dryer connections Jackson",
      "category": "Amenity",
      "h1_title": "Apartments with Washer Dryer Connections Jackson",
      "h2_subtitle": "Find ease at White Oak Estates in Jackson, with apartments offering convenient washer and dryer connections, perfect for your busy lifestyle.",
      "page_copy": "Welcome to White Oak Estates, where convenience meets modern living in Jackson. Our apartments feature efficient washer and dryer connections, offering you the ease of in-unit laundry solutions right at home. Simplify your everyday routine by ensuring chores are quicker and more manageable, allowing you more time to enjoy life.\n\nLocated in the heart of Jackson, MS, our community also boasts a range of exceptional amenities including two sparkling swimming pools and a fully equipped fitness center. Enjoy spacious, renovated floor plans with luxurious features such as granite kitchen countertops. Managed by a professional onsite team, White Oak Estates seamlessly integrates convenience and comfort tailored to your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer Dryer Connections Jackson",
      "seo_description": "Explore White Oak Estates in Jackson, offering apartments with washer dryer connections and modern amenities. Experience convenient living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-jackson-ms",
      "search_query": "1 bedroom apartments in Jackson MS",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Jackson MS",
      "h2_subtitle": "Discover the perfect fit at White Oak Estates with spacious 1 bedroom apartments in Jackson, MS, designed for comfort and convenience.",
      "page_copy": "Welcome to White Oak Estates, the ideal destination for those seeking modern 1 bedroom apartments in Jackson, MS. Our community provides well-appointed, spacious layouts filled with natural light and contemporary finishes, offering the perfect retreat after a busy day.\n\nSituated in a prime location, White Oak Estates combines your love for comfort with essential amenities. Enjoy access to amenities such as two sparkling swimming pools and a state-of-the-art fitness center. Each apartment is designed with your convenience in mind, featuring modern kitchen upgrades and the security of controlled access. Our professional onsite management team is here to ensure you feel right at home. Experience the best of Jackson living at White Oak Estates.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Jackson MS",
      "seo_description": "Explore White Oak Estates for spacious 1 bedroom apartments in Jackson, MS. Enjoy modern amenities and a convenient location today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-hinds-county",
      "search_query": "2 bedroom apartments near Hinds County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Hinds County",
      "h2_subtitle": "Discover comfort and style at White Oak Estates, offering 2 bedroom apartments near Hinds County with modern amenities and spacious designs.",
      "page_copy": "White Oak Estates invites you to explore our inviting community, featuring 2 bedroom apartments near Hinds County. Our homes provide ample living space, perfect for families or roommates, with thoughtfully designed interiors and plenty of natural light. Each unit boasts modern finishes, making it easy to find the perfect match for your lifestyle.\n\nLocated conveniently close to Hinds County, our community ensures you have access to the best Jackson has to offer. Residents enjoy luxurious amenities such as two sparkling swimming pools and a cutting-edge fitness center. With renovated apartments and a welcoming neighborhood atmosphere, White Oak Estates is an excellent choice for those looking for a vibrant place to call home. Experience a blend of convenience and comfort today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Hinds County",
      "seo_description": "Find spacious 2 bedroom apartments at White Oak Estates near Hinds County. Enjoy modern amenities and prime location in Jackson, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-39206",
      "search_query": "3 bedroom apartments 39206",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in 39206",
      "h2_subtitle": "Experience spacious living at White Oak Estates with our expansive 3 bedroom apartments in the 39206 area, offering modern comforts and community perks.",
      "page_copy": "Welcome to White Oak Estates, your destination for spacious and stylish 3 bedroom apartments in the 39206 area. Our expansive floor plans provide ample room for the whole family, accommodating both relaxation and entertainment needs. Embrace a home featuring modern finishes and plenty of room to grow.\n\nLocated in Jackson, MS, within the 39206 zip code, our vibrant community offers superb amenities designed to enrich your lifestyle. Unwind by our two sparkling swimming pools or keep active in our contemporary fitness center. Each apartment is complemented by features like granite kitchen countertops and reliable controlled access. Managed by a professional onsite team, White Oak Estates promises comfort and convenience in every corner.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in 39206",
      "seo_description": "Explore White Oak Estates for spacious 3 bedroom apartments in the 39206 area. Enjoy modern amenities and a convenient location in Jackson, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-near-belhaven-university-jackson-ms",
      "search_query": "apartments near belhaven university jackson ms",
      "category": "School",
      "h1_title": "Apartments Near Belhaven University",
      "h2_subtitle": "Find your ideal home at White Oak Estates, conveniently located near Belhaven University in Jackson, MS, offering comfort and modern amenities.",
      "page_copy": "White Oak Estates is the perfect spot for those seeking vibrant living near Belhaven University in Jackson, MS. Our community offers beautifully renovated apartments in a tranquil yet convenient location. Ideal for students and professionals alike, these homes provide both comfort and easy access to campus life.\n\nJust a short drive from Belhaven University, residents can enjoy a balance of work and play with our outstanding community amenities. Dive into one of our two sparkling swimming pools or stay fit in our modern fitness center. Each apartment features contemporary kitchens with granite countertops, creating a perfect environment for study sessions or relaxation. Live in style and comfort at White Oak Estates, where convenience meets community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belhaven University",
      "seo_description": "Discover White Oak Estates, offering modern apartments near Belhaven University in Jackson, MS, with convenient amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "rentals-close-to-millsaps-college-hinds-county",
      "search_query": "rentals close to millsaps college hinds county",
      "category": "School",
      "h1_title": "Rentals Close to Millsaps College",
      "h2_subtitle": "Explore White Oak Estates for rentals close to Millsaps College, located in Hinds County, offering modern amenities and a vibrant community.",
      "page_copy": "Discover a welcoming community at White Oak Estates, offering premium rentals close to Millsaps College in Hinds County. Whether you're eyeing proximity to campus for ease of commuting or simply seeking a vibrant lifestyle nearby, our location provides both.\n\nEach apartment at White Oak Estates delivers a cozy yet modern living experience. Residents enjoy a variety of luxurious amenities including two pristine swimming pools and a fully-equipped fitness center. Our renovated apartments are designed with modern finishes, ensuring that you have the ideal combination of style and function right at your doorstep. Enjoy the convenience and comfort of rentals near Millsaps College today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Millsaps College",
      "seo_description": "Find modern rentals at White Oak Estates close to Millsaps College, Hinds County. Enjoy stylish living with great amenities nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "holmes-community-college-nearby-apartments-jackson-39206",
      "search_query": "holmes community college nearby apartments jackson 39206",
      "category": "School",
      "h1_title": "Nearby Apartments to Holmes Community College",
      "h2_subtitle": "Find comfortable living at White Oak Estates, Jackson 39206, with nearby apartments perfect for Holmes Community College students and faculty.",
      "page_copy": "Students, faculty, and locals looking for nearby apartments to Holmes Community College in Jackson's 39206 zip code will find White Oak Estates the perfect choice. Our vibrant community offers a peaceful and convenient lifestyle, complemented by state-of-the-art facilities and a caring management team.\n\nNestled within close proximity to Holmes Community College, these apartments offer a blend of convenience and modern living. Residents enjoy amenities such as two sparkling swimming pools and a cutting-edge fitness center, ideal for destressing after a day on campus. Our meticulously renovated homes feature granite kitchen countertops, providing both aesthetic appeal and functionality. Experience a supportive community tailored for academic and personal success at White Oak Estates.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Holmes Community College",
      "seo_description": "Experience White Oak Estates in Jackson, 39206, offering nearby apartments to Holmes Community College with excellent amenities tailored for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-near-tougaloo-college-jackson",
      "search_query": "apartments near tougaloo college jackson",
      "category": "School",
      "h1_title": "Apartments Near Tougaloo College",
      "h2_subtitle": "Discover White Oak Estates, ideally located near Tougaloo College in Jackson, offering modern amenities and a welcoming community atmosphere.",
      "page_copy": "White Oak Estates is perfectly situated for those in search of apartments near Tougaloo College in Jackson. Whether you're a student or faculty member, our community provides easy access to the college while offering a peaceful retreat from the hustle and bustle of academic life.\n\nEnjoy the benefits of living close to campus without sacrificing the comforts of home. Our community boasts a variety of luxurious amenities, including two refreshing swimming pools and a fitness center. Each apartment is thoughtfully designed with modern renovations and features such as granite kitchen countertops. Experience the convenience and vibrant lifestyle at White Oak Estates, where academic focus meets home-like comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tougaloo College Jackson",
      "seo_description": "Find your perfect home at White Oak Estates, offering apartments near Tougaloo College in Jackson with top-notch amenities and a supportive community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-near-st-dominic-hospital-jackson-ms",
      "search_query": "apartments near St. Dominic Hospital Jackson MS",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Dominic Hospital",
      "h2_subtitle": "Explore White Oak Estates in Jackson, MS, featuring apartments that are conveniently located near St. Dominic Hospital, with modern comforts and amenities.",
      "page_copy": "White Oak Estates offers an ideal living solution for those seeking apartments near St. Dominic Hospital in Jackson, MS. Our community is designed to provide both convenience and tranquility, making it a perfect choice for hospital staff, patients, and their families.\n\nLocated just a short drive from St. Dominic Hospital, our apartments provide a convenient and serene living environment. Residents can take advantage of amenities such as two sparkling swimming pools and a fully-equipped fitness center. Each apartment is elegantly renovated, featuring granite kitchen countertops that blend style with practicality. Discover the blend of convenience and comfort at White Oak Estates, making life near St. Dominic Hospital smooth and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Dominic Hospital Jackson",
      "seo_description": "Discover White Oak Estates in Jackson, MS, offering apartments with easy access to St. Dominic Hospital and featuring top-notch amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-close-to-baptist-medical-center-hinds-county",
      "search_query": "apartments close to Baptist Medical Center Hinds County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Baptist Medical Center",
      "h2_subtitle": "Find comfort and convenience at White Oak Estates, with apartments strategically close to Baptist Medical Center in Hinds County.",
      "page_copy": "For those working or undergoing treatment at Baptist Medical Center, living conveniently close in Hinds County is a top priority. White Oak Estates offers the perfect solution with modern apartments just a brief drive away. Our community provides a peaceful sanctuary with resort-style amenities and spacious living options.\n\nResidents benefit from accessing amenities like our two sparkling swimming pools and a modern fitness center, creating a balanced lifestyle in busy Jackson. Elegantly renovated, our apartments feature granite kitchen countertops and thoughtful design, ensuring both style and functionality. Choose White Oak Estates for comfortable, convenient living near Baptist Medical Center, where quality and location harmoniously meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Baptist Medical Center",
      "seo_description": "Live at White Oak Estates, offering modern apartments close to Baptist Medical Center in Hinds County with premium amenities for a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-near-lefleurs-bluff-state-park-jackson-ms",
      "search_query": "apartments near LeFleur's Bluff State Park Jackson MS",
      "category": "Park",
      "h1_title": "Apartments Near LeFleur's Bluff State Park",
      "h2_subtitle": "Discover the charm of White Oak Estates, offering apartments near LeFleur's Bluff State Park in Jackson, MS, where nature and comfort meet.",
      "page_copy": "White Oak Estates is ideally situated for those who love being close to nature, offering apartments near LeFleur's Bluff State Park in Jackson, MS. Enjoy easy access to outdoor adventures, from scenic walks to picnics, while living in a comfortable and modern community.\n\nOur residents enjoy a harmonious blend of relaxation and activity, with amenities that include two beautiful swimming pools and a fitness center for keeping active. Each apartment is tastefully renovated, featuring sleek granite kitchen countertops and inviting living spaces. Whether you're an outdoor enthusiast or simply seeking a comfortable home, White Oak Estates offers the perfect balance of nature and modern living, just moments from LeFleur's Bluff.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near LeFleur's Bluff State Park",
      "seo_description": "Find your ideal home at White Oak Estates, featuring modern apartments near LeFleur's Bluff State Park in Jackson, MS, with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "white-oak-estates-close-to-freedom-ridge",
      "search_query": "White Oak Estates close to Freedom Ridge",
      "category": "Park",
      "h1_title": "White Oak Estates Near Freedom Ridge",
      "h2_subtitle": "Experience the welcoming atmosphere at White Oak Estates, conveniently located close to Freedom Ridge for a blend of comfort and accessibility.",
      "page_copy": "White Oak Estates offers a prime location for those looking to be near Freedom Ridge. Situated in the heart of Jackson, MS, our community provides a unique blend of tranquility and convenience, perfect for anyone seeking an accessible and serene lifestyle.\n\nEnjoy resort-style amenities such as two sparkling swimming pools and a modern fitness center, all within a community that's just a stone's throw from Freedom Ridge. Our apartments are elegantly renovated, with features like granite kitchen countertops that offer both style and functionality. At White Oak Estates, you're not just finding a place to live, but a community you'll love, with easy access to local attractions and daily conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "White Oak Estates Near Freedom Ridge",
      "seo_description": "Explore White Oak Estates, offering modern amenities and spacious living near Freedom Ridge in Jackson, MS, for a perfect blend of comfort and location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "jackson-ms-rentals-near-old-trace-park",
      "search_query": "Jackson MS rentals near Old Trace Park",
      "category": "Park",
      "h1_title": "Jackson MS Rentals Near Old Trace Park",
      "h2_subtitle": "Discover Jackson, MS rentals that are a stone's throw from Old Trace Park. White Oak Estates offers the ideal location and community amenities.",
      "page_copy": "Experience the perfect blend of nature and convenience with Jackson, MS rentals near Old Trace Park. At White Oak Estates, you're just minutes away from this beautiful park, offering endless opportunities for outdoor fun and relaxation.\n\nOur community provides residents with resort-style living, featuring amenities like two sparkling swimming pools and a modern fitness center. Enjoy spacious, renovated apartments with granite kitchen countertops that combine style with functionality. Whether you're taking in the beauty of Old Trace Park or unwinding at home, White Oak Estates offers the best of both worlds—easy access to nature and modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackson MS Rentals Near Old Trace Park",
      "seo_description": "White Oak Estates offers ideal Jackson, MS rentals with modern amenities, just minutes from the scenic Old Trace Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "apartments-by-strawberry-patch-park-hinds-county",
      "search_query": "apartments by Strawberry Patch Park in Hinds County",
      "category": "Park",
      "h1_title": "Apartments by Strawberry Patch Park",
      "h2_subtitle": "Find your ideal home at White Oak Estates, offering apartments conveniently located by Strawberry Patch Park in Hinds County.",
      "page_copy": "Nestled close to the picturesque Strawberry Patch Park in Hinds County, White Oak Estates provides an unmatched living experience with our well-situated apartments. Enjoy the tranquility and beauty of the nearby park, perfect for leisurely walks and outdoor activities.\n\nWhite Oak Estates offers a vibrant community with resort-style amenities, including two refreshing swimming pools and a state-of-the-art fitness center. Our renovated apartments boast elegant features like granite kitchen countertops, designed for your comfort and style. Choose White Oak Estates for a lifestyle where nature's beauty and modern conveniences seamlessly blend together, all near Strawberry Patch Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Strawberry Patch Park",
      "seo_description": "Explore White Oak Estates, offering modern amenities and renovated apartments by Strawberry Patch Park in Hinds County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164876",
      "source": "generator",
      "page_item_url": "white-oak-estates-adjacent-to-flowood-liberty-park",
      "search_query": "White Oak Estates adjacent to Flowood Liberty Park",
      "category": "Park",
      "h1_title": "White Oak Estates by Flowood Liberty Park",
      "h2_subtitle": "Live adjacent to Flowood Liberty Park at White Oak Estates. Delight in the perfect location and impressive amenities this community offers.",
      "page_copy": "White Oak Estates boasts a prime location adjacent to Flowood Liberty Park, offering residents the opportunity to enjoy nature's splendor alongside modern amenities. Our Jackson, MS community provides an unparalleled living experience, strategically situated near this popular park.\n\nResidents of White Oak Estates benefit from resort-style living with two sparkling swimming pools, a cutting-edge fitness center, and beautifully renovated apartments. Each unit features elegant granite kitchen countertops, delivering both style and utility. Choose White Oak Estates as your home and relish the convenience of being close to Flowood Liberty Park, where leisure and comfort converge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black refrigerator, dishwasher, and stove.",
        "public_id": "019d082d-ed10-70b5-8ab6-9a53778c04cd",
        "storage_key": "property/6767906449164876/019d082d-ed10-70b5-8ab6-9a53778c04cd.webp",
        "width": 682,
        "height": 429
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "White Oak Estates by Flowood Liberty Park",
      "seo_description": "White Oak Estates offers premium living with top amenities, situated adjacent to Flowood Liberty Park in Jackson, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4518"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "7940450682"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5453169"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_y_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=y"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P4CTNBKH"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_ag_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=ag"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_br_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=br"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_rp_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=rp"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_y_title",
      "type": "STRING",
      "value": "Yelp"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_zu_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=zu"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "601-706-5126"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_ag_title",
      "type": "STRING",
      "value": "Apartment Guide"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_br_title",
      "type": "STRING",
      "value": "Brochure/Flyer"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "601-844-9387"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "601-800-5291"
    },
    {
      "ID": "custom_knock_rp_title",
      "type": "STRING",
      "value": "RentPath"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "601-891-1531"
    },
    {
      "ID": "custom_knock_y_number",
      "type": "STRING",
      "value": "601-891-5323"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "601-327-4705"
    },
    {
      "ID": "custom_knock_zu_title",
      "type": "STRING",
      "value": "Zumper"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_ag_number",
      "type": "STRING",
      "value": "601-222-3684"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "601-775-2031"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "601-841-5270"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_br_number",
      "type": "STRING",
      "value": "601-706-5366"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "601-589-8465"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "601-222-3479"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "601-706-5181"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "601-873-6334"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_rp_number",
      "type": "STRING",
      "value": "601-222-3952"
    },
    {
      "ID": "custom_knock_zu_number",
      "type": "STRING",
      "value": "601-871-6144"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "601-803-8226"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "601-603-2429"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "601-800-0857"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "601-843-6119"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "601-673-5107"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "601-365-7118"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "601-775-2103"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "601-851-8126"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "26354748042"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "601-603-2438"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "601-688-9753"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "326796ae7bc11efd"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "601-866-3301"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "601-603-2235"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "601-780-5074"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "601-803-8312"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "601-751-7829"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "601-851-3958"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "601-851-3244"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "601-327-4491"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.whiteoaksestates.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "601-258-7635"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "601-873-6334"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "4518",
  "custom_repli_id": "7940450682",
  "custom_realpage_id": "5453169",
  "custom_knock_a_link": "https://www.whiteoaksestates.com?utm_knock=a",
  "custom_knock_g_link": "https://www.whiteoaksestates.com?utm_knock=g",
  "custom_knock_r_link": "https://www.whiteoaksestates.com?utm_knock=r",
  "custom_knock_w_link": "https://www.whiteoaksestates.com?utm_knock=w",
  "custom_knock_y_link": "https://www.whiteoaksestates.com?utm_knock=y",
  "custom_knock_z_link": "https://www.whiteoaksestates.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-P4CTNBKH",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_ag_link": "https://www.whiteoaksestates.com?utm_knock=ag",
  "custom_knock_al_link": "https://www.whiteoaksestates.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.whiteoaksestates.com?utm_knock=ar",
  "custom_knock_br_link": "https://www.whiteoaksestates.com?utm_knock=br",
  "custom_knock_cl_link": "https://www.whiteoaksestates.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.whiteoaksestates.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.whiteoaksestates.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.whiteoaksestates.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_rp_link": "https://www.whiteoaksestates.com?utm_knock=rp",
  "custom_knock_w_title": "Property Website",
  "custom_knock_y_title": "Yelp",
  "custom_knock_z_title": "Zillow",
  "custom_knock_zu_link": "https://www.whiteoaksestates.com?utm_knock=zu",
  "custom_knock_a_number": "601-706-5126",
  "custom_knock_ads_link": "https://www.whiteoaksestates.com?utm_knock=ads",
  "custom_knock_ag_title": "Apartment Guide",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.whiteoaksestates.com?utm_knock=bnr",
  "custom_knock_br_title": "Brochure/Flyer",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "601-844-9387",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.whiteoaksestates.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.whiteoaksestates.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.whiteoaksestates.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.whiteoaksestates.com?utm_knock=psa",
  "custom_knock_r_number": "601-800-5291",
  "custom_knock_rp_title": "RentPath",
  "custom_knock_w_number": "601-891-1531",
  "custom_knock_y_number": "601-891-5323",
  "custom_knock_z_number": "601-327-4705",
  "custom_knock_zu_title": "Zumper",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_ag_number": "601-222-3684",
  "custom_knock_al_number": "601-775-2031",
  "custom_knock_amap_link": "https://www.whiteoaksestates.com?utm_knock=amap",
  "custom_knock_ar_number": "601-841-5270",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_br_number": "601-706-5366",
  "custom_knock_cl_number": "601-589-8465",
  "custom_knock_fb_number": "601-222-3479",
  "custom_knock_fl_number": "601-706-5181",
  "custom_knock_gp_number": "601-873-6334",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.whiteoaksestates.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_rp_number": "601-222-3952",
  "custom_knock_zu_number": "601-871-6144",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "601-803-8226",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.whiteoaksestates.com?utm_knock=bcard",
  "custom_knock_bnr_number": "601-603-2429",
  "custom_knock_cfres_link": "https://www.whiteoaksestates.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "601-800-0857",
  "custom_knock_lgp_number": "601-843-6119",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.whiteoaksestates.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "601-673-5107",
  "custom_knock_psa_number": "601-365-7118",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "601-775-2103",
  "custom_knock_bandit_link": "https://www.whiteoaksestates.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.whiteoaksestates.com?utm_knock=flyers",
  "custom_knock_osoc_number": "601-851-8126",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "26354748042",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "601-603-2438",
  "custom_knock_cfres_number": "601-688-9753",
  "custom_knock_chatgpt_link": "https://www.whiteoaksestates.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "326796ae7bc11efd",
  "custom_knock_dirmail_link": "https://www.whiteoaksestates.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "601-866-3301",
  "custom_knock_propbro_link": "https://www.whiteoaksestates.com?utm_knock=propbro",
  "custom_knock_bandit_number": "601-603-2235",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "601-780-5074",
  "custom_knock_outbound_link": "https://www.whiteoaksestates.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.whiteoaksestates.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "601-803-8312",
  "custom_knock_dirmail_number": "601-751-7829",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "601-851-3958",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "601-851-3244",
  "custom_knock_revcards_number": "601-327-4491",
  "custom_knock_maintenance_link": "https://www.whiteoaksestates.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "601-258-7635",
  "custom_ppc_tracking_phone_number": "601-873-6334"
};

export const generatedAt = '2026-10-07T17:13:19.016Z';
